import Env from '../envConfig/environment.json';
export const Environment = Env.Environment;
export const baseUrl = () => {
  let BASE_URL = '';
  if (Environment === 'Development') {
    BASE_URL = 'https://dev-api-v2.beinghumans.co/';
  } else if (Environment === 'Production') {
    BASE_URL = 'https://api-v2.beiinghuman.com/';
  } else if (Environment === 'Staging') {
    // Staging Tier B (dev-backed: shares dev Mongo/SSM). Deploy target of the
    // beiinghuman-backend-staging pipeline.
    BASE_URL = 'https://staging-backend.beiinghuman.com/';
  } else {
    BASE_URL = 'http://localhost:3000/';
  }
  return BASE_URL;
};
export const coiTrackerUrl = () => {
  // Hosted COI tracker origin (reused for postMessage targeting, so no trailing
  // path). Dev + Staging share the dev box (dev-backed, same dev Cognito pool);
  // only Production uses the prod box. Pointing staging at the prod box would
  // send a dev-pool token prod can't resolve -> COI sign-in fails.
  if (Environment === 'Production') {
    return 'https://coi-tracker.beiinghuman.com';
  }
  if (Environment === 'Development' || Environment === 'Staging') {
    return 'https://dev-coi-tracker.beiinghuman.com';
  }
  // Anything else is a laptop: baseUrl() already falls back to localhost:3000
  // for the API, so the trackers fall back to their local dev ports too.
  return 'http://localhost:5173';
};
export const lienWaiverTrackerUrl = () => {
  // Hosted Lien Waiver tracker origin (reused for postMessage targeting, so no
  // trailing path). Mirrors coiTrackerUrl: Dev + Staging share the dev box
  // (dev-backed, same dev Cognito pool); only Production uses a prod box.
  if (Environment === 'Production' || Environment === 'Development' || Environment === 'Staging') {
    return 'https://lien-waiver-tracker.beiinghuman.com';
  }
  return 'http://localhost:5174';
};

export const cardReceiptsUrl = () => {
  // Hosted card receipt automation (cc-receipt-automation) origin, no trailing
  // path, so it doubles as the postMessage target. Mirrors lienWaiverTrackerUrl:
  // one deployed box serves Dev, Staging and Production alike.
  if (Environment === 'Production' || Environment === 'Development' || Environment === 'Staging') {
    return 'https://cc-receipts.beiinghuman.com';
  }
  return 'http://localhost:5175';
};
// Bank Reconciliation (bank-rec) and Vendor Statement Reconciliation
// (vendor-rec). Unlike the trackers above, ONE deployed box serves every
// environment: each app reads `?env=` once on load, stores it, and sends it back
// to its own backend as the `X-BH-Env` header. So the origin is a constant and
// the environment travels in the query string — see subappEnvParam().
//
// No localhost fallback: both apps only accept a token from an opener on their
// own allow-list of deployed customer-app origins, so a laptop session gets the
// subapp's own sign-in either way.
export const bankRecUrl = () => 'https://bank-rec.beiinghuman.com';
export const vendorRecUrl = () => 'https://vendor-rec.beiinghuman.com';

// The `env` query value bank-rec/vendor-rec expect. Staging is dev-backed (same
// dev Cognito pool), exactly as coiTrackerUrl treats it, so it goes to 'dev'
// along with Development and a laptop.
export const subappEnvParam = () => (Environment === 'Production' ? 'prod' : 'dev');
export const w9TrackerUrl = () => {
  // Hosted W-9 tracker origin (reused for postMessage targeting, so no trailing
  // path). Mirrors lienWaiverTrackerUrl rather than coiTrackerUrl: ONE deployed
  // box serves Dev, Staging and Production alike, because there is no dev box
  // -- dev-w9-tracker.beiinghuman.com does not resolve.
  //
  // The caveat coiTrackerUrl documents still applies and is worth re-reading
  // before a dev box is ever added: dev and prod use different Cognito pools,
  // so this only works while the deployed tracker's TIER_B_BASE_URL points at
  // the same Tier B the calling frontend authenticates against.
  if (
    Environment === 'Production' ||
    Environment === 'Development' ||
    Environment === 'Staging'
  ) {
    return 'https://w9-tracker.beiinghuman.com';
  }
  // Local ports: 5173 coi-tracker, 5174 lien-waiver, 5175 cc-receipts (see
  // cardReceiptsUrl below), so w9-tracker takes 5176 and they can all run at
  // once.
  return 'http://localhost:5176';
};

// Origin of the hosted support assistant (the Gradio Space behind Ask Bahi).
// Mirrors coiTrackerUrl/lienWaiverTrackerUrl: an origin, no trailing path, so it
// can also be used as a postMessage target.
//
// Both branches return the same Space today, because only one is deployed. The
// seam is here rather than inlined because there is a concrete reason to want a
// second one: the Space emails rishi@, support@ and ubaid@ every time it cannot
// answer a question (send_email_if_needed in the Space's app.py), so every dev
// and staging session a developer spends poking at the bot raises real support
// alerts against the production knowledge base. Standing up a dev Space is then
// a one-line change here.
export const supportAssistantOrigin = () => {
  if (Environment === 'Production') {
    return 'https://beiinghuman-bh-support-doc-chatbot.hf.space';
  }
  return 'https://beiinghuman-bh-support-doc-chatbot.hf.space';
};

// Shown on the side panel's header and used as the iframe's accessible title.
export const ASK_ASSISTANT_TITLE = 'Ask Bahi';

export const StripeKey = () => {
  let STRIPE_KEY;
  if (Environment === 'Production') {
    STRIPE_KEY =
      'pk_live_51Nag7hJsKreadjPIAZZFwkIBKQpk4wAPrlHtKwZ2IuHaS1SLITTEczsKu2VFAmDgzvFHWrcaAoNCvSL7htJJV9ww00B3YSC3ME';
  } else {
    STRIPE_KEY =
      'pk_test_51NZrH0C0wgKISC6Qdz5K1tfa7ZzPdrOfIS2tiSlIIMF4gyvh53WtJGRc7BepwUxBaaq6RbzMuvQeRUEUfDBzC9IQ00ZpsChaX4';
  }
  return STRIPE_KEY;
};
export const InvoiceEmail = () => {
  let MAIL;
  if (Environment === 'Production') {
    MAIL = 'process@documents.beiinghuman.com';
  } else {
    MAIL = 'process_dev@documents.beiinghuman.com';
  }
  return MAIL;
};

export const SUPPORT_PASSWORD = 'Ubaid477!';
export const NETWORK_ERROR = 'NETWORK_ERROR';

export const tableTabNames = {
  TO_REVIEW: 'To Review',
  COMPANY_DOCUMENTS: 'Company Documents',
  IN_REVIEW: 'In Review',
  SEARCH: 'search'
};

export const ValidationMessages = {
  REQUIRED: 'This field is required',
  INVALID_EMAIL: 'Invalid email address',
  INVALID_USERNAME: 'User name cannot contain special characters',
  PASSWORD_CHECK:
    'At least 8 characters, including uppercase, lowercase, number and special character',
  INVALID_PAYMENT_TYPE: 'Payment Type must not be empty',
  INVALID_AMOUNT: 'Amount is invalid. It must not be empty and contain only digits',
  INVALID_CHECKNO: 'Check No is invalid. It must not be empty and must not exceed 10 characters.',
  INVALID_PAYMENT_DATE: 'Payment Date is invalid, It must be in mm/dd/yyyy format',
  INVALID_PAYMENT_AMOUNT:
    'Payment Amount is invalid. It must not be empty, contain only digits, and must not exceed 10 digits.',
  INVALID_PAYMENT: 'CURRENT PAYMENT DUE is invalid. It must not be empty and contain only digits',
  INVALID_G702_TOTAL:
    'TOTAL is invalid. It must not be empty and contain only digits — retainage and Current Payment Due are calculated from it',
  INVALID_RETAINAGE:
    'RETAINAGE PERCENTAGE is invalid. It must not be empty and contain only digits',
  // The invoice's retainage box may be left empty (most invoices withhold
  // nothing), so its message must not tell the reviewer to fill it in.
  INVALID_RETAINAGE_OPTIONAL: 'RETAINAGE PERCENTAGE is invalid. It must contain only digits',
  INVALID_RETAINAGE_RANGE:
    'RETAINAGE PERCENTAGE must be a percentage between 0 and 100 \u2014 not the retainage dollar amount printed beside it on the form',
  INVALID_DATE: 'Invoice Date is invalid, It must be in mm/dd/yyyy format',
  INVALID_DUE_DATE: 'Due Date is invalid, It must be in mm/dd/yyyy format',
  INVALID_EXPIRATION_DATE: 'Expiration Date is invalid, It must be in mm/dd/yyyy format',
  INVALID_RECEIPT_DATE: 'Receipt Date is invalid, It must be in mm/dd/yyyy format',
  INVALID_ESTIMATE_DATE: 'Quote Date is invalid, It must be in mm/dd/yyyy format',
  INVALID_DT_DATE: 'Delivery Date is invalid, It must be in mm/dd/yyyy format',
  INVALID_PO_DATE: 'PO Date is invalid, It must be in mm/dd/yyyy format',
  INVALID_G702_DATE: 'PERIOD TO is invalid, It must be in mm/dd/yyyy format',
  INVALID_PASSWORD: 'Email Address or Password is incorrect',
  INVALID_VENDOR: 'Vendor name must not be empty',
  INVALID_VENDOR_LENGTH: 'Vendor must not be grearter than 41 characters',
  INVALID_FOUNDATION_VENDOR_LENGTH: 'Vendor must not be grearter than 150 characters',
  INVALID_FOUNDATION_FROM_CONTRACTOR_LENGTH:
    'From contractor must not be grearter than 150 characters',
  INVALID_INVOICENUMBER: 'Invoice number must not be empty',
  INVALID_INVOICELENGTH: 'Invoice number must not be grearter than 20 characters',
  INVALID_VISTA_INVOICELENGTH: 'Invoice number must not be greater than 30 characters',
  INVALID_RECEIPTNUMBER: 'Receipt number must not be empty',
  INVALID_ESTIMATENUMBER: 'Quote number must not be empty',
  INVALID_PONUMBER: 'Purchase Order must not be empty',
  INVALID_RECEIPTLENGTH: 'Receipt number must not be grearter than 20 characters',
  INVALID_ESTIMATELENGTH: 'Quote number must not be grearter than 20 characters',
  INVALID_POLENGTH: 'Purchase Order must not be grearter than 10 characters',
  INVALID_APPLICATION_LENGTH: 'Application number must not be grearter than 20 characters',
  INVALID_PROJECTNUMBER: 'Application number must not be empty',
  INVALID_CONTRACTOR: 'From contractor must not be empty',
  INVALID_CONTRACTOR_LENGTH: 'From contractor must not be grearter than 41 characters',
  FORGOT_PASSWORD: 'Forgot Password ?',
  CREATE_PASSWORD: 'Create new password',
  HEADING: 'Forget password Being Humans Account',
  INVALID_TOTAL: 'Total Fees is invalid. It must only contain digits',
  INVALID_SUBTOTAL: 'Subtotal is invalid. It must only contain digits',
  PASSWORD_SCHEMA:
    'Password should be at least 8 characters, including uppercase, lowercase, number and special character (except #)',
  VENDOR_NUM_NOT_MATCHED_IN_LIST:
    'Please select the vendor Number from your uploaded list to create PO within your connected ERP',
  INVALID_DELIVERYLENGTH: 'Document number must not be grearter than 20 characters',
  INVALID_DELIVERYNUMBER: 'Document number must not be empty',
  INVALID_TRANSACTION_DATE: 'Transaction Date is invalid, It must be in mm/dd/yyyy format',
  INVALID_DISCOUNT_DATE: 'Discount Date is invalid, It must be in mm/dd/yyyy format',
  INVALID_DISCOUNT: 'Discount is invalid. It must contain digits or % with it',
  INVALID_DISCOUNT_VISTA: 'Discount is invalid. It must be a numeric amount',
  DISCOUNT_DATE_REQUIRED: 'Discount Date must not be empty',
  DISCOUNT_REQUIRED: 'Discount cannot be empty',
  INVALID_FOUNDATION_DESCRIPTION_LENGTH: 'Description must not be greater than 30 characters',
  EMPTY_TRANSACTION_DATE: 'Transaction Date must not be empty',
  EMPTY_INVOICE_DATE: 'Invoice Date must not be empty',
  EMPTY_PAYMENT_DATE: 'Payment Date must not be empty',
  EMPTY_DUE_DATE: 'Due Date must not be empty',
  VISTA_EMPTY_TRANSACTION_DATE: 'GL Date must not be empty and it must be the 1st day of a month',
  INVALID_VISTA_TRANSACTION_DATE:
    'GL Date is invalid, It must be in mm/dd/yyyy format and be the first day of a month',
  VISTA_DUE_DATE_TOO_OLD: 'Due Date must not be older than 1 year',
  VISTA_GL_DATE_CLOSED_PERIOD: 'GL Date is not in an open AP period',
  // Appended to every Vista GL Date message with the company's window filled in,
  // e.g. "... Open periods: 06/2026 to 05/2033"
  VISTA_GL_OPEN_PERIODS: 'Open periods:'
};

export const AdminTable = {
  CSV: 'Download CSV',
  XML: 'Download XML',
  ALL_DOCS: 'All Documents',
  SYNC: 'Sync',
  EXPORTABLE_FILE: 'Exportable File',
  SYNC_USER: 'Sync from ERP',
  DOWNLOAD_REPORT: 'INYA',
  HELPER_FOR_REPORT: 'Download INYA(Invoices not yet approved) by approver',
  FETCH_FROM_ERP: 'Sync Users',
  FETCH_ACTION: 'This action will override you existing erp users. Are you still want to proceed?',
  SEARCH: 'Search'
};

export const CustomerDataTable = {
  USERNAME: 'Username',
  EMAIL: 'Email',
  USER_ROLE: 'User Role',
  SIGN_UP: 'Sign Up',
  ACTIONS: 'Actions',
  DELETE: 'Delete',
  RESEND: 'Resend',
  INVITE_USER: 'Invite a new user to the system.',
  CONFIRM_DELETE_USER: 'Are you sure you want to delete this user',
  CANCEL: 'Cancel'
};

// Copy for the delivery-ticket suggestion panel — what will be attached when
// this invoice is approved, and how many other tickets still need attaching by
// hand.
// Written from the reviewer's side of the screen: what is going to happen to
// this invoice, not what the scorer did to arrive at it.
export const DELIVERY_TICKET_SUGGESTION = {
  WILL_ATTACH: 'Will attach on approval',
  SHORTLISTED: 'Closest match · not attached automatically',
  // Where to go if they want it after all. The suggestion card deliberately
  // does not attach: every attachment goes through one write path, and a second
  // one here could disagree with what the invoice ends up with.
  ATTACH_HINT: 'Attach it from Remove/Attach Delivery Ticket if it belongs here.',
  UNTITLED: 'Delivery ticket',
  VIEW: 'View',
  MORE: 'more',
  CLOSE: 'Dismiss',
  ENLARGE: 'Enlarge delivery ticket',
  SHRINK: 'Close enlarged delivery ticket',
  VENDOR: 'Vendor',
  JOB: 'Job',
  DATE: 'Ticket date',
  PO: 'PO',
  DELIVERED: 'Delivered',
  WHY: 'Why this one',
  REASON_ALL_ITEMS: 'Every item on this ticket is on the invoice',
  REASON_SOME_ITEMS: 'items on this ticket are on the invoice',
  REASON_PO: 'Same purchase order',
  REASON_DATE: 'Delivered close to the invoice date',
  CHIP_ATTACHED: 'Ticket attaching',
  CHIP_SHORTLISTED_ONE: 'ticket shortlisted',
  CHIP_SHORTLISTED_MANY: 'tickets shortlisted',
  OTHERS_HINT: 'tickets match. Only the best one attaches — add the rest from Attach.',
  PREVIOUS_MATCH: 'Previous',
  NEXT_MATCH: 'Next',
  LINE_MATCHED: 'Found on this invoice',
  LINE_UNMATCHED: 'Not found on this invoice',
  DECLINE: "Don't attach this ticket",
  DECLINING: 'Setting aside…',
  DECLINED_TOAST: 'This ticket will not be attached automatically.',
  DECLINE_FAILED: 'Could not set that ticket aside. Try again.',
  // Said next to the action, because "don't attach" could reasonably be read as
  // "never attach a ticket to this invoice", which is not what it does.
  DECLINE_HINT: 'Only this ticket. Another match can still attach, and you can attach this one by hand.'
};

export const Profile = {
  ADD_FOLDER_ID: 'Add Google Drive folder id',
  ADD_PATH: 'Add local path of Documents folder',
  PROFILE_HEADING: 'Profile Details',
  SELECT_ERP: 'Select ERP Option',
  TOTAL_INVOICE: 'Total Documents',
  TOTAL_PAGES: 'Total pages',
  SAVE: 'Save',
  // Settings save themselves as they are changed — there is no Save button, so
  // every control has to report its own outcome.
  SAVED: 'Saved',
  NOT_SAVED: 'Not saved',
  AUTOSAVE_SAVING: 'Saving…',
  AUTOSAVE_SAVED: 'All changes saved',
  AUTOSAVE_FAILED: "Couldn't save",
  AUTOSAVE_HINT: 'Changes save automatically',
  NO_EDIT_PERMISSION: 'Your role cannot change company settings.',
  AUTOSAVE_FAILED_TOAST: "That change wasn't saved.",
  // Both halves failed: the write, and then the re-read that would have put the
  // screen back. Nothing on screen can be trusted to match the server, and the
  // page cannot fix that on its own — only a reload can.
  AUTOSAVE_REVERT_FAILED:
    "That change wasn't saved, and your settings couldn't be reloaded — this screen may not match what is stored. Refresh the page before changing anything else.",
  ENABLE_JOB: ' Cost Type, Job Id & Cost Id',
  ENABLE_PHASE: ' Phase',
  G702_PERMISSION: 'G702 Import',
  PO_MATCHING: 'Purchase Order/ Subcontract Matching',
  DOC_SPLITTER: 'Doc Splitter',
  DUPLICATE_CHECK: 'Duplicate Bill No Check',
  BACK: 'Back',
  BEIING_HUMAN: 'Beiing Human',
  ENABLE_DUPLICATION: 'Duplicate File Check',
  DOC_LIMIT: 'Document Limit',
  DISCONNECT_INTEGRATION_MESSAGE: 'Disconnect your previous integration to change ERP type.',
  RECEIPT_UPLOAD: 'Receipt Import',
  // Key kept from when this shipped as "Statement Import" (statementUpload).
  STATEMENT_UPLOAD: 'Vendor Reconciliation',
  QUOTE_UPLOAD: 'Quote and PO Import',
  DELIVERY_TICKET_UPLOAD: 'Delivery Ticket Import',
  DELIVERY_TICKET_CODING: 'Require coding for Delivery Ticket',
  DELIVERY_TICKET_AUTO_ATTACH: 'Auto attach Delivery Tickets',
  DELIVERY_TICKET_MANAGER_APPROVAL: 'Manager approves their own Delivery Tickets',
  DELIVERY_TICKET_AUTO_APPROVE: 'Auto-approve complete delivery tickets',
  SERVICE_AND_EQUIPMENT: 'Service Code and Equipment No',
  DEFAULT_CODE: 'Default Coding',
  JOB_BUDGETING: 'Job Budget based Coding',
  LINEITEM_TOTAL_MATCHING: 'Line Items Total Matching',
  LINEITEM_AMOUNT_CALCULATION: 'Line Items Amount Calculation',
  MISCELLANEOUS_AMOUNT_CALCULATION: 'Miscellaneous Amount Calculation',
  EXPENSE_BASED_CODING: 'Expense Based Coding',
  DEPARTMENT_BASED_GL_CODING: 'Department Based GL Coding',
  QUICKBOOKS_NOTFICATION: 'Intuit and QuickBooks are registered trademarks of Intuit Inc.',
  QUICKBOOKS_PERMISSION: ' Used with permission.',
  SAVE_VENDOR_CODE: 'Save Vendor Codes',
  VENDOR_CODE_TOOLTIP:
    'Remembers the coding a user last saved for each vendor and prefills it on that vendor’s next document. Our own memory, not your ERP’s',
  ACCURACY_BASED_POINTING: 'Confidence score based Pointing',
  ACCURACY_TOOLTIP:
    'Delivery Ticket: Green for 85% and above , Yellow for 55% to 84% , Red for below 55% . Other: Green for 99% and above , Yellow for 85% to 98% , Red for below 85%',
  CONSOLIDATE_LINEITEMS: 'Consolidate Line items',
  GL_DIVISION: 'GL Division',
  COMPANY_EMAIL: 'Company Email',
  VALIDATE: 'Validate',
  CANCEL: 'Cancel',
  EDIT_EMAIL: 'Edit Email',
  FAQ_MAINTENANCE: 'FAQ Maintenance',
  GOOGLE_DRIVE_SYNC: 'Sync data with Google Drive',
  DELETE: 'Delete',
  UPLOAD: 'Upload',
  VERIFY: 'Verify',
  DELETE_DRIVE_DOCUMENTS: 'Delete Google Drive Documents',
  SYNC_DRIVE: 'Sync Google Drive Documents',
  DOC_ASSIGNMENT: 'Document Assignment',
  DOC_ASSIGNMENT_USERS: 'Select users who can assign document',
  C_LEVEL_NOT_FOUND: 'C Level does not exist',
  STATEMENT_RECONCILIATION: 'Statement Reconciliation Maintenance',
  MANAGER_AS_FIRST_APPROVER: 'Manager as First Approver',
  DUPLICATE_NUMBER_TOOLTIP:
    'Detects documents with the same bill number against vendor to prevent duplicate processing. Checked automatically after extraction, on the document, and again at approval.',
  DOC_SPLITTER_TOOLTIP:
    'Splits multi-document pdfs into individual, correctly categorized documents.',
  PO_MATCHING_TOOLTIP:
    'Matches invoices against purchase orders or subcontracts to verify items, quantity, and price.',
  PO_TO_CODES_MAPPING: 'PO to Codes Mapping',
  PO_TO_CODES_MAPPING_TOOLTIP:
    'For vendors that print a code in the invoice’s PO box. When enabled, an extracted PO number is matched against your job codes, GL accounts, and equipment numbers; on a match it becomes the document’s job, GL account or equipment and the PO is cleared.',
  RECEIPT_UPLOAD_TOOLTIP: 'Upload and manage expense receipts directly within the application.',
  STATEMENT_UPLOAD_TOOLTIP:
    'Turn on if your team uses Vendor Reconciliation. Statements, whether uploaded, split or emailed in, then go to Vendor Reconciliation instead of the review queue, and the app appears in the Apps menu. When off, anything detected as a statement is processed as an invoice.',
  G702_TOOLTIP: 'Upload and manage G702 documents for progress billing.',
  SERVICE_AND_EQUIPMENT_TOOLTIP:
    'Enables the use of service codes and equipment numbers for more detailed tracking and reporting.',
  DEFAULT_CODE_TOOLTIP:
    'Copies the default coding your accountants set on the vendor in the ERP onto new documents.',
  JOB_BUDGETING_TOOLTIP:
    'Enables job budgeting features for better financial tracking of projects.',
  LINEITEM_TOTAL_MATCHING_TOOLTIP:
    'Validates that line item totals match the document’s overall total.',
  LINEITEM_AMOUNT_CALCULATION_TOOLTIP:
    'Validates that line item amounts match their quantities and unit prices.',
  MISCELLANEOUS_AMOUNT_CALCULATION_TOOLTIP:
    'Validates that the header total equals the sum of line item amounts minus the miscellaneous amount.',
  DEPARTMENT_BASED_GL_CODING_TOOLTIP:
    'Fills the GL account from the Vista department: a job uses its JC department and the selected cost type (or a phase override), and a work order uses its scope\'s SM department (material cost GL). Warns when the GL picked differs. Needs departments synced, and the connector to send Department on jobs and work-order scopes.',
  EXPENSE_BASED_CODING_TOOLTIP:
    'Fills the Reviewer Group from the GL account selected on Account Details, and warns when an Expense-typed document has none. Applies to the Unapproved batch type only. Needs a full GL account re-sync first — until that has run, no GL account has a reviewer group and the field will be left empty.',
  GOOGLE_DRIVE_SYNC_TOOLTIP:
    'Enables automatic synchronization with Google Drive for document storage.',
  CONSTRUCTION_COMPANY_TOOLTIP: 'Allow cost type, job ID, and cost ID for accurate job costing.',
  PHASE_TOOLTIP: 'Enables the use of project phases.',
  DUPLICATE_DOC_TOOLTIP:
    'Blocks a file that has already been uploaded, even if it was renamed. Compares the file itself, before extraction.',
  QUOTE_UPLOAD_TOOLTIP: 'Upload quotes and purchase orders for reference and automated matching.',
  DELIVERY_TICKET_UPLOAD_TOOLTIP: 'Upload delivery tickets to streamline receiving and invoicing.',
  DELIVERY_TICKET_CODING_TOOLTIP:
    'Show coding fields on delivery tickets and require a Job Id before one can be approved. The job is what lets a ticket be matched to an invoice.',
  DELIVERY_TICKET_AUTO_ATTACH_TOOLTIP:
    'Attach the best-matching approved delivery ticket to an invoice automatically when the invoice is approved.',
  DELIVERY_TICKET_AUTO_APPROVE_TOOLTIP:
    'A delivery ticket whose vendor, date, ticket number and line items were all read, and which is not a duplicate, is approved automatically. Anything missing is flagged in red for the person who has the ticket. Coding is not required.',
  DELIVERY_TICKET_MANAGER_APPROVAL_TOOLTIP:
    'A delivery ticket a manager uploads is approved when that manager approves it, instead of going to AP for a second approval. Only the manager who uploaded the ticket can do this, and only for delivery tickets. Requires Manager as first approver.',
  CONSOLIDATE_LINEITEMS_TOOLTIP:
    'Combines line items into a single entry for cleaner and more accurate matching.',
  GL_DIVISION_TOOLTIP: 'Enables the use of GL divisions for enhanced financial reporting.',
  MANAGER_AS_FIRST_APPROVER_TOOLTIP:
    'Sets the manager as the first approver in the approval workflow.',
  JOB_BUDGET_MANAGEMENT: 'Job Budget Management',
  JOB_BUDGET_MANAGEMENT_TOOLTIP:
    'Enables PM-owned budgets with Budget vs Committed vs Actual tracking per job.',
  BATCH_TYPE: 'Select Batch Type',
  CONNECT_PLAID: 'Connect to Plaid',
  DISCONNECT_PLAID: 'Disconnect Plaid',
  PLAID_CONNECTED: 'Plaid Connected',
  PLAID_SECTION_TITLE: 'Bank Account Integration',
  APPROVED_NOTIFICATION_TOOLTIP:
    'Number of days after invoice is approved to notify (e.g. 3 = invoice in approved status for 3+ days).',
  NOTIFICATION_DAYS_HEADING: 'Approved Invoice Notification Days',
  WORK_ORDER: 'Work Order',
  WORK_ORDER_TOOLTIP: 'Enable Work Order for better project tracking',
  AI_CODING: 'AI Code Prediction',
  AI_CODING_PERMISSION_TOOLTIP:
    'Fills only codes left blank by your other coding rules. Never overrides them.',
  // One company flag, `codingMemory`, and today it only ever learns the vendor —
  // hence the vendor-specific label. The mechanism itself is generic (an extracted
  // value corrected the same way often enough becomes the default), so the flag
  // name stays generic for the code types that come later.
  CODING_MEMORY: 'Vendor Coding Memory',
  CODING_MEMORY_TOOLTIP:
    'When enabled, a repeated vendor correction is remembered and applied on its own. Once the same extracted vendor has been corrected to the same vendor on 5 approved documents, that correction is applied automatically to future documents. Only approvals count towards the 5 — correcting and saving a document without approving it does not.',
  VALIDATIONS: 'Coding Validations',
  VALIDATIONS_TOOLTIP: 'Enables coding validations to ensure code quality and compliance.',
  VIEW_TAX_AS_COLUMN: 'Display Tax as a Column',
  FREIGHT_AS_LINE_ITEM: 'Freight as a Separate Line Item',
  FREIGHT_AS_LINE_ITEM_TOOLTIP:
    'When enabled and the Freight field is switched on in the document field configuration, freight is shown as its own Freight line item.',
  CONSOLIDATE_FREIGHT_LINE_ITEM: 'Consolidate Freight Line Item',
  CONSOLIDATE_FREIGHT_LINE_ITEM_TOOLTIP:
    'When enabled, consolidating line items also folds the Freight line into the consolidated line. When disabled, freight always stays its own line, keeping only the coding entered on it.',
  VIEW_TAX_AS_COLUMN_TOOLTIP:
    'Displays tax as columns per line item instead of a separate tax row.',
  TAX_CALCULATION: 'Tax Calculation',
  TAX_CALCULATION_TOOLTIP:
    'When enabled, tax is calculated on total and Tax Code/Type are required.',
  PAYMENT_TERM_PERMISSION: 'Payment Terms',
  PAYMENT_TERM_PERMISSION_TOOLTIP: 'When enabled, documents carry a Payment Terms field.',
  SHIPPING_ADDRESS_PERMISSION: 'Shipping Address',
  SHIPPING_ADDRESS_PERMISSION_TOOLTIP: 'When enabled, documents carry a Shipping Address field.',
  CALCULATE_TERMS_AND_DISCOUNTS_IN_ERP: 'Calculate Terms & Discounts in ERP',
  CALCULATE_TERMS_AND_DISCOUNTS_IN_ERP_TOOLTIP:
    'When enabled, the ERP handles due date, discount date, and discount calculations from payment terms. When disabled, the application auto-fills these fields from the selected payment term.',
  AUTO_ENQUEUE_DOCS: 'Auto Enqueue Documents',
  AUTO_ENQUEUE_DOCS_TOOLTIP:
    'When enabled, approved documents are automatically pushed to ERP processing at the end of the day without any manual action.',
  // Same company flag, named after whatever the ERP calls the field — GL Date on
  // Vista (month/year only), Transaction Date everywhere else.
  //
  // Labelled "Invoice" since the G702 got a switch of its own: two rows reading
  // "Transaction Date as Current Date" and "G702 Transaction Date as Current Date"
  // left the first one looking like the company-wide setting the second overrode,
  // which is not what either does. The flag key is unchanged.
  TRANSACTION_DATE_AS_CURRENT_DATE: 'Invoice Transaction Date as Current Date',
  TRANSACTION_DATE_AS_CURRENT_DATE_TOOLTIP:
    "When enabled, the Transaction Date on an invoice or receipt is pre-filled with today's date instead of the invoice date.",
  GL_DATE_AS_CURRENT_DATE: 'Invoice GL Date as Current Date',
  GL_DATE_AS_CURRENT_DATE_TOOLTIP:
    'When enabled, the GL Date on an invoice is pre-filled with the 1st of the current month instead of the invoice date.',
  // The posting date is decided at EXPORT instead: the file / ERP payload carries
  // the day the invoice was exported from Beiing Human, and the canvas field is
  // read-only. Invoices and receipts only — a G702 posts for its billing period.
  // Mutually exclusive with "… as Current Date" on the settings screen.
  TRANSACTION_DATE_AS_EXPORT_DATE: 'Invoice Transaction Date as Export Date',
  TRANSACTION_DATE_AS_EXPORT_DATE_TOOLTIP:
    'When enabled, the Transaction Date on an invoice or receipt is set to the date it is exported from Beiing Human, and the field can no longer be edited on the review screen.',
  GL_DATE_AS_EXPORT_DATE: 'Invoice GL Date as Export Date',
  GL_DATE_AS_EXPORT_DATE_TOOLTIP:
    'When enabled, the GL Date on an invoice or receipt is set to the month it is exported from Beiing Human, and the field can no longer be edited on the review screen.',
  TRANSACTION_DATE_SET_AT_EXPORT:
    'Set automatically to the date this document is exported from Beiing Human.',
  GL_DATE_SET_AT_EXPORT:
    'Set automatically to the month this document is exported from Beiing Human.',
  // The same behaviour asked separately for a pay application, and a SEPARATE
  // company flag: a monthly G702 is posted for a period, so wanting today's date
  // on the invoices that arrive daily says nothing about wanting it here.
  G702_TRANSACTION_DATE_AS_CURRENT_DATE: 'G702 Transaction Date as Current Date',
  G702_TRANSACTION_DATE_AS_CURRENT_DATE_TOOLTIP:
    "When enabled, the Transaction Date on a G702 pay application is pre-filled with today's date instead of the period end date.",
  G702_GL_DATE_AS_CURRENT_DATE: 'G702 GL Date as Current Date',
  G702_GL_DATE_AS_CURRENT_DATE_TOOLTIP:
    'When enabled, the GL Date on a G702 pay application is pre-filled with the 1st of the current month instead of the period end date.',
  NOTIFICATION_PERMISSION: 'Real-Time Notifications',
  NOTIFICATION_PERMISSION_TOOLTIP:
    'When enabled, real-time notifications are shown. When disabled, no notification is displayed and the app only refreshes its data in the background.',
  VENDOR_COI_COMPLIANCE: 'Vendor COI Compliance',
  VENDOR_COI_COMPLIANCE_TOOLTIP:
    "When enabled, each vendor's Certificate of Insurance (COI) compliance status is shown on the documents list and the document review screen.",
  VENDOR_LIEN_WAIVER_COMPLIANCE: 'Lien Waiver Compliance',
  VENDOR_LIEN_WAIVER_COMPLIANCE_TOOLTIP:
    "When enabled, each invoice's lien waiver coverage status (from the Lien Waiver Tracker) is shown on the document review screen beside the COI status, so approvers can see which invoices are actually clear to pay. Shows your own data only; it sends nothing to anyone.",
  VENDOR_EMAIL_REPLIES: 'Vendor Email Replies',
  VENDOR_EMAIL_REPLIES_TOOLTIP:
    "Off by default. When enabled, emails sent to a vendor from a document carry a reply address that comes back to Beiing Human: the vendor's reply is added to that document's Activity and the person who sent the email is notified. When disabled, replies go to the sender's own inbox and do not appear in the app.",
  LIEN_WAIVER_OUTREACH_ENABLED: 'Lien Waiver Outreach',
  LIEN_WAIVER_OUTREACH_ENABLED_TOOLTIP:
    'Off by default. When enabled, we email your subcontractors on your behalf, under your company name, asking them to sign a lien waiver for the work they have billed — with a secure link that needs no login. Nothing is sent to anyone while this is off. This is separate from COI Compliance Outreach; turning one on does not turn on the other.',
  FOUNDATION_G702_EXPORT: 'Check Pay Applications Before Export',
  FOUNDATION_G702_EXPORT_TOOLTIP:
    'Off by default, and it no longer controls retainage \u2014 every pay application now exports the full amount billed this period as the Header Amount, with the retainage carried separately for Foundation to hold back and the subcontract number in the PO/Sub No column. What this switch adds is a check in front of the file: an export fails, naming the invoice, when a Header Amount does not equal the sum of its own distribution lines, when retainage is owed but was not calculated, or when a job-cost line carries no job number. Those are the three things the FSI Importer rejects one at a time, so the whole batch is held back instead.',
  AUTO_FILL_DESCRIPTION: 'Description from Line Items',
  AUTO_FILL_DESCRIPTION_TOOLTIP:
    'When enabled, an invoice whose Description is blank is filled with the description of its highest-dollar line item, trimmed to the 30 characters the ERP accepts. A Description read from the invoice, or typed by a user, is never replaced.',
  COI_OUTREACH_ENABLED: 'COI Compliance Outreach',
  COI_OUTREACH_ENABLED_TOOLTIP:
    'Off by default. When enabled, we email your vendors — and their insurance agents — a secure upload link asking for a renewed Certificate of Insurance as one expires. Emails are sent on your behalf and carry your company name. Nothing is sent to anyone while this is off. Requires Vendor COI Compliance.',
  // NAMED AT RENDER TIME, because write-back is no longer Foundation-only.
  // `{erp}` is filled from the company's own ERP in userProfile.getAllSwitches —
  // a Vista customer reading "Write COI Dates to Foundation" on their own
  // settings screen would reasonably think the switch belonged to someone else.
  COI_WRITE_BACK_ENABLED: 'Write COI Dates to {erp}',
  COI_WRITE_BACK_ENABLED_TOOLTIP:
    'Off by default. When enabled, the COI tracker\u2019s {erp} comparison lets you write verified certificate expiration dates onto your vendors\u2019 insurance dates in {erp} \u2014 one date at a time, or every difference at once after you review the full list. This is the only setting that changes data inside your accounting system. Dates are only ever filled in or corrected, never cleared, and only from a certificate someone has marked Verified. Requires Vendor COI Compliance.',
  MANAGER_UPDATE_CODES: 'Manager Content Editing',
  MANAGER_UPDATE_CODES_TOOLTIP: 'Allow managers to modify document content information.',
  ANYONE_CAN_RESOLVE_QNA: 'Anyone Can Resolve Q&A',
  ANYONE_CAN_RESOLVE_QNA_TOOLTIP:
    'Off by default. When enabled, anyone who can open a document can resolve any open Q&A thread on it. When disabled, a question can only be resolved by the person who raised it, by someone with the same role, or by an Owner, Accountant or Support user when the question was raised by one of those three.',
  DISABLE_ERP_VALIDATIONS_FOR_APPROVERS: 'Validations for Last Approver Only',
  DISABLE_ERP_VALIDATIONS_FOR_APPROVERS_TOOLTIP:
    'When enabled, coding validations will only apply to the last approver, not all approvers.',
  DEFAULT_RECEIPT_VENDOR: 'Default Receipt Vendor',
  DEFAULT_RECEIPT_VENDOR_TOOLTIP:
    'Set default vendors for receipts. When enabled, select vendors from the list.',
  SELECT_DEFAULT_VENDOR: 'Select Default Vendors'
};

export const plaidMessages = {
  CONNECT_SUCCESS: 'Bank account connected successfully.',
  CONNECT_ERROR: 'Failed to connect bank account. Please try again.',
  DISCONNECT_SUCCESS: 'Bank account disconnected successfully.',
  DISCONNECT_ERROR: 'Failed to disconnect bank account. Please try again.',
  LINK_TOKEN_ERROR: 'Unable to initialize Plaid. Please try again later.',
  EXCHANGE_ERROR: 'Failed to exchange token. Please try again.'
};

export const dropzoneData = {
  INFO: 'Import Files',
  SUCCESS: 'SUCCESS',
  FILE_STATUS: 'No File Imported',
  UPLOADING_INFO: "Drag 'n' drop files here, or click to select files",
  BTN_TEXT: 'Submit',
  PDF_UPLOADING_INFO: 'Drag and drop a PDF, then split it into multiple files.',
  SPLIT_PDF: 'Split PDF',
  SELECT_TYPE: 'Select the document type',
  DROP_TO_IMPORT: 'Drop files to import',
  DROP_SKIPPED: 'Only PDF, JPG and PNG files can be imported. Skipped:'
};
// What Import Files takes — the modal's dropzone and a drop on the documents page.
export const IMPORT_FILE_ACCEPT = {
  'image/jpeg': ['.jpeg', '.jpg'],
  'application/pdf': ['.pdf'],
  'image/png': ['.png']
};
export const docAssignment = {
  ASSIGN_DOC: 'Assign Document',
  SELECT_USERS: 'Select Users'
};

export const protectedSchema = {
  ALREADY_REGISTERED: 'Already have an account?',
  VERIFY_ACCOUNT: ' Verify your identity',
  RESEND_CODE: 'You can resend code in',
  CODE_VARIFICATION: 'Enter the Email verification code and your new password below.',
  SECONDS: 'seconds',
  SIGNIN_HEADING: 'Login',
  SEND_EMAIL_TEXT:
    ' Enter the Email Address associated with your account and we will send an email with instructions to reset your password.'
};

export const generatePo = {
  DOCUMENT_CONTENT: 'Document Content',
  PURCHASE_ORDER: 'Purchase Order',
  DESCRIPTION: 'Description',
  TOTAL: 'Total',
  QUANTITY: 'Quantity',
  UNIT_PRICE: 'Unit Price',
  SHOW_LINEITEMS: 'Show LineItems',
  UOM: 'UOM',
  TAX: 'Tax %',
  SUBTOTAL: 'Subtotal',
  TAX_RATE: 'Tax Rate',
  TAX_AMT: 'Tax Amt'
};

export const headings = {
  TOKEN: 'token',
  ERROR_MESSAGE: 'Something went Wrong',
  ERP_SELECT: ' Select ERP Option',
  HEADING: 'Login',
  SIGNUP_HEADING: 'Sign up',
  CREATE_ACCOUNT: 'Create Account',
  SIGNUP_QUESTION: "Don't have an account? ",
  SUBMIT: 'submit',
  PASSWORD: 'password',
  EMAIL: 'email',
  EMAIL_PLACEHOLDER: 'Email*',
  WORK_EMAIL_PLACEHOLDER: 'Work Email*',
  NAME_PLACEHOLDER: 'Name*',
  USER: 'userName',
  PASSWORD_PLACEHOLDER: 'Password*',
  GIVEN_NAME: 'given_name',
  VERIFICATION_CODE: 'Verification code',
  CONFIRM: 'Confirm',
  CHANGE_PASSWORD: 'Change Password',
  VENDOR: 'Vendor',
  CONTINUE: 'Continue',
  CANCEL: 'Cancel',
  AUTH_HEADING: 'Welcome to',
  BEIING_HUMAN: 'Beiing Human',
  ADD_USER: 'Add New User',
  ADD_VENDOR: 'Add New Vendor',
  REGISTER_USER: 'Register User',
  PAYMENT_DONE: 'Payment processed Successfully',
  THANK_YOU: 'Thank You!',
  PAYMENT_SUCCESSFULL: 'Your Payment Has Been Successful',
  EDIT_USER: 'Edit User'
};

export const documentDetails = {
  BACK: 'Back',
  DOCUMENT_DETAILS: 'Document Details',
  ACCOUNT_DETAILS: 'Account Details',
  PAYMENT_DETAILS: 'Payment Details',
  // Shared by the canvas and the verified/exported detail view, which print the
  // same page images through the same helper.
  PRINT_DOCUMENT: 'Print Document',
  PRINT_ERROR: 'Could not open the print dialog for this document'
};

export const canvasDetails = {
  // Hover text on a coding cell the AI model filled (see coddingFields.jsx).
  AI_FILLED_TOOLTIP: 'AI',
  TOTAL_AMOUNT: 'Total Amount',
  DOCS: 'Review Document',
  APPROVE: 'Approve',
  // Shown on the Approve hover when the document resolves to no further approver, so the
  // absence is stated rather than left as a tooltip that never opens.
  NO_APPROVER_RESOLVED: 'No further approver is set — approving completes this document.',
  CANCEL: 'Cancel',
  DOC_TYPE: 'Document Type',
  GL_ACCOUNT: 'GL Account',
  PHASE: 'Phase',
  JOB_ID: 'Job id',
  COST_ID: 'Cost id',
  COST_TYPE: 'Cost Type',
  VERIFY: 'Verify All',
  MATCH_PO: 'Match PO',
  MATCH_SUBCONTRACT: 'Match SC',
  VENDOR_NUMBER: 'Vendor Number',
  GL_YEAR: 'GL Year',
  GL_PERIOD: 'GL Period',
  RETENTION_AMOUNT: 'Retention Amount',
  FETCH_PO: 'Fetch PO',
  FETCH_PO_DESCRIPTION:
    'This Action will override your changes with the data from PO. Please confirm to proceed',
  FETCH_SC_DESCRIPTION:
    'This Action will override your changes with the data from Subcontract. Please confirm to proceed',
  FETCH_WO: 'Fetch Work Order',
  FETCH_WO_DESCRIPTION:
    'This Action will override your changes with the data from Work Order. Please confirm to proceed',
  PROJECT_ID: 'Project Id',
  CLASS: 'Class',
  RESET: 'Reset',
  RESET_DESCRIPTION: 'Reset Line Items from Invoice Image',
  INVALID_VENDOR_NAME:
    'This does not exist in ERP. Please update your information or sync the data.',
  CONTENT_VENDOR: 'vendor',
  FROM_CONTRACTOR: 'from_contractor',
  CONTENT_PURCHASEORDER: 'purchase_order',
  CONTENT_TOTAL: 'total',
  DESCRIPTION: 'Description',
  ZOOMING_ERROR: 'Zooming does not work on this screen',
  DT_LINEITEM: 'Delivery Ticket must have at least 1 line item',
  VISTA_LINEITEM: 'There must be at least 1 line item',
  SAME_CODES: 'Account details and Line items codes must be same',
  TOTAL_PROMPT_MESSAGE:
    'Document Total does not match with line items total. Are you sure you want to proceed?',
  DISCOUNT_PERCENTAGE:
    'Enter discounted amount or discount %. If a % is entered, the discounted amount will be calculated based on the total for ERP export',
  SAVE_STATE_TOOLTIP: 'Save Document State',
  SAVE: 'Save',
  DOCUMENT_DETAILS: 'Document Details',
  CHECKING_DOCUMENT_DUPLICATION: 'Validating Document Content'
};

export const toasters = {
  VERIFICATION: 'User verified Successfully! Please Sign-in to continue',
  IS_CODE_SENT: 'Code has been sent to your email address',
  EMAIL_NOTE: 'Enter the verification code sent to your email address.',
  RESEND_CODE_LINK: ' Resend Code',
  EMAIL_ERROR: 'User is already Registered with given Email Address.',
  PASSWORD_CHANGED: 'Password Changed Successfully',
  TIME_ERROR: 'wait for the time to end',
  PO_MATCHED_ERROR: 'PO already exists with this Purchase Order'
};

export const userRoles = {
  ACCOUNTANT: 'Accountant',
  AP: 'AP Person',
  ADMIN: 'Admin',
  OWNER: 'Owner',
  CLEVEL: 'C_Level',
  MANAGER: 'Manager',
  VENDOR: 'Vendor',
  SUPPORT: 'Support'
};

export const QwcPopup = {
  PASSWORD_INFO: 'Enter Password to download file',
  NOTICE:
    'Please remember the password that you enter here. You need to provide the same password in your QuickBooks Web Connector',
  NOTE: 'Note:',
  DOWNLOAD_QWC_FILE: 'Download QuickBooks Web Connector File'
};
export const IntegrationPage = {
  INTEGRATION_MESSAGE: 'you have not selected any Integration',
  RECORD: 'No Record',
  QUICKBOOKS_ONLINE_SUBTITLE: 'Integrate your Beiing Human with QuickBooks.',
  QUICKBOOKS_DESKTOP_SUBTITLE: 'Integrate your Beiing Human with QuickBooks.',
  FOUNDATION_SUBTITLE: 'Integrate your Beiing Human with Foundation Software',
  SESSION_EXPIRE: 'Session expired ! Please again Login to continue',
  SOMETHING_WENT_WRONG: 'Something went wrong',
  // Sign-in succeeded and the profile read did not. Says so explicitly, because
  // the generic message sent this to support as a password or outage problem —
  // Frank M. Booth spent from 10 to 13 Aug clearing caches and re-entering
  // passwords for a fault that was neither. Names the account rather than the
  // credentials, and does not suggest retrying the password.
  PROFILE_UNAVAILABLE_AT_SIGN_IN:
    "Your password was accepted, but we couldn't load your account permissions, so we've stopped here rather than sign you in with the wrong ones. Please try again in a moment, and contact support if it persists — this is not a password problem.",
  VIEWPOINT_VISTA: 'Integrate your Beiing Human with ViewPoint Vista',
  DELTEK_COMPUTEREASE: 'Integrate your Beiing Human with Deltek ComputerEase',
  VIEWPOINT_SPECTRUM: 'Integrate your Beiing Human with ViewPoint Spectrum',
  CONNECTED_COMPANY: 'ERP Company:',
  DATABASE: 'Database:',
  CONFIRM_DISCONNECT:
    'Are you sure you want to disconnect the integration? If you have an approval policy configured, it will also be deactivated.'
};

// Settings → Integrations → Acumatica. Connection is OAuth (authorization code):
// the customer registers Beiing Human in their own Acumatica, pastes the client here,
// and signs in on Acumatica's page; the backend sends the browser back to
// /userProfile with ?erp=acumatica&erpStatus=connected|error.
export const AcumaticaIntegration = {
  SUBTITLE: 'Integrate your Beiing Human with Acumatica',
  CONNECT_TITLE: 'Connect Acumatica',
  SETUP_HELP:
    'Register Beiing Human in Acumatica under Connected Applications (SM303010) with the Authorization Code flow, then enter the details below. You will be taken to Acumatica to sign in.',
  INSTANCE_URL: 'Acumatica address',
  INSTANCE_URL_PLACEHOLDER: 'https://yourcompany.acumatica.com',
  TENANT: 'Tenant',
  CLIENT_ID: 'Client ID',
  CLIENT_SECRET: 'Client secret',
  BRANCH: 'Branch (optional)',
  CONNECT: 'Connect',
  RECONNECT: 'Reconnect',
  NEEDS_RECONNECT: 'Acumatica needs to be reconnected',
  REQUIRED_FIELDS: 'Enter the Acumatica address, tenant, Client ID and client secret.',
  CONNECTED_TOAST: 'Acumatica is connected. Your lists are syncing.',
  CONNECT_FAILED: 'Acumatica could not be connected.',
  BILL_STATE: 'Acumatica Bill State',
  BILL_STATE_OPTIONS: [
    { value: 'hold', label: 'On Hold' },
    { value: 'approval', label: 'Submit for Approval' },
    { value: 'release', label: 'Release' }
  ]
};

export const Stripe = {
  PAYMENT_CLEARED_MESSAGE: 'There is no pending payment available',
  HEADING: ' Enter Details to Pay'
};

export const REACT_APP_KEY = 'ahDP1BdbHP8B16auXvYBA0yzZEOlDm2W8m3FYgXdxZ/q5rDd2HEjxyjoUlor+xxr';

export const options = [
  'QuickBooks Desktop',
  'Foundation',
  'Accounting Seed',
  'Deltek Computer Ease',
  'Default'
];

export const signupOptions = [
  'QuickBooks Online',
  'QuickBooks Desktop',
  'Foundation',
  'Accounting Seed',
  'Deltek Computer Ease',
  'ViewPoint Vista',
  'ViewPoint Spectrum',
  'Acumatica',
  'Other'
];

export const batchTypeOptions = [
  { name: 'Approved', value: 'Approved' },
  { name: 'Unapproved', value: 'UnApproved' }
];
export const docAssignOptions = ['default', 'Auto', 'Manual'];

// The company setting's off position: documents are never assigned to an
// accountant, so anything keyed on an assignment has nothing to show.
export const DEFAULT_ACCOUNTANT_ASSIGNMENT = 'default';

// The setting's third position (see docAssignOptions above: 'default' | 'Auto' |
// 'Manual'). The Assigned To column is for this one only — 'Auto' assigns
// documents too, so the column would carry real data there, but showing it there
// is not what was asked for.
export const MANUAL_ACCOUNTANT_ASSIGNMENT = 'Manual';

// Rows per page on the documents table. 50 is a ceiling, not a taste: advanced
// search reads the same page size and Tier B's advanced-search schema rejects a
// limit above 50. The Approved tab's "All" is stored as pageSize 10 on top of these.
// The default is the ceiling (Gmail's 50), measured against 25 on prod: see PR.
export const DOCUMENTS_PAGE_SIZE_OPTIONS = [25, 50];
export const DEFAULT_DOCUMENTS_PAGE_SIZE = 50;

// Row density of the documents table, per browser. MUI's standard rows are 52px,
// compact 36px — roughly 40% more rows in the same height.
export const DOCUMENTS_TABLE_DENSITY_KEY = 'documentsTableDensity';
export const DOCUMENTS_TABLE_DENSITIES = ['standard', 'compact'];

export const topNav = {
  DASHBOARD: 'Dashboard',
  BACK: 'Back',
  VIEW_DOC: 'View Supporting Document',
  RECONSILE_STATEMENTS: 'Reconcile Statements',
  COI_TRACKER: 'COI Tracker',
  LIEN_WAIVER_TRACKER: 'Lien Waiver Tracker',
  W9_TRACKER: 'W-9 Tracker',
  CARD_RECEIPTS: 'Card Receipts',
  BANK_REC: 'Bank Reconciliation',
  VENDOR_REC: 'Vendor Reconciliation',
  APPS_MENU: 'Apps'
};
export const uploadFileArray = ['Vendor', 'Cost Ids', 'Job Ids', 'Gl Accounts', 'Purchase Order'];

export const TooltipMessages = {
  SPLIT_PDF_MESSAGE: 'Split multi-page PDFs into separate documents before processing',
  SEND_EMAIL: 'Get the processed data in your email.',
  DOWNLOAD_FILES: 'Download Selected Documents',
  DOWNLOAD_ALL_FILES: 'Download All Documents',
  SYNC_DATA: 'Fetch updated data from your integrated ERP',
  MANUAL_UPLOAD: 'Upload single csv file having account information. Such as PO, Vendors etc.',
  MANUAL_DOWNLOAD: 'Download files having account information. Such as PO, Vendors etc.',
  UPLOAD_FILE_MESSAGE: 'Import documents for processing',
  SEARCH_MESSAGE:
    'You can Search by Vendor, Cost Id, Job Id, Cost Type, Total, Purchase Order, Document Number.',
  LINEITEMS_NOT_FOUND: 'Line item does not exist',
  AMOUNT_NOT_MATCHED: 'Amount do not match',
  DUPLICATE_LINEITEM: 'Duplicate Line item',
  SEE_DUPLICATE: 'Review Duplicate Document',
  SEARCH_ATTACHMENT_MESSAGE: 'You can Search by Attachment Id.',
  DESCRIPTION_LIMIT_MESSAGE: 'Only first 30 characters will be picked at the time of export',
  ADVANCED_SEARCH: 'Advanced Search'
};

// The activity panel's identity header. It opens over a table whose rows can
// share a vendor, a PO and a file name — the panel has to say which ROW it came
// from, or it is describing one of nine identical-looking things.
export const activityIdentity = {
  DOC_NO: 'Doc No',
  AMOUNT: 'Amount',
  RECEIVED: 'Received',
  FILE: 'File',
  NO_VENDOR: 'No vendor'
};

export const accountDetailsComponent = {
  GL_ACCOUNT: 'GL Account',
  COST_ID: 'Cost Id',
  PHASE: 'Phase',
  JOB_ID: 'Job Id',
  COST_TYPE: 'Cost Type',
  ACTIVITY: 'Activity',
  SHOW_ACTIVITY: 'Activity',
  PURCHASE_ORDER: 'Purchase Order',
  VENDOR: 'Vendors',
  OVERRIDE_LIST: 'Do you want to override the previous list?',
  CLASS: 'Class',
  PROJECT_ID: 'Project Id',
  ITEM: 'Item',
  EQUIPMENT_NO: 'Equipment No',
  GL_DIVISION: 'Gl Division',
  SERVICE_CODE: 'Service Code',
  APPROVED_BY: 'Approved By',
  SITTING_WITH: 'Currently Sitting With',
  PENDING_APPROVERS: 'Pending Approvers',
  NOT_APPLIED: 'Policy Not Applied',
  APPROVERS: 'Approvers',
  DOCUMENT_STATUS: 'Document Status',
  STATUS_APPROVED: 'Approved'
};
export const manualUserComponent = {
  ADD_USER: 'Add Manual User',
  AMOUNT_CHECK: 'Amount must be greater than $0.50',
  UPLOAD: 'Upload file',
  MAKE_PAYMENT: 'User has been notified to make payment',
  SEND_BILL: 'Send bill to user',
  SEND_BILL_VENDOR: 'Send bill to vendor',
  AMOUNT: 'Amount $'
};
export const lineItemsText = {
  SHOW_LINEITEMS: 'Show Line Items',
  HIDE_LINEITEMS: 'Hide Line Items',
  MISSING_VALUE: 'Required value is missing',
  DELETE_ALL: 'Delete All'
};
export const documentStatusText = {
  POPULATED: 'Populated',
  APPROVED: 'Approved',
  PENDING: 'Pending',
  REJECT: 'Reject',
  WAITING: 'Waiting For Approval',
  ONHOLD: 'on Hold',
  ERROR: 'Error',
  DUPLICATE: 'Duplicate',
  EXPORT: 'Exported',
  ATTACHED: 'Attached',
  GENERATED: 'Generated',
  PROCESSING: 'Processing',
  IN_REVIEW: 'In Review',
  REJECTED: 'Rejected',
  FAILURE: 'Failure',
  IN_ERP: 'In ERP',
  IN_QNA: 'In Q&A',
  VERIFIED: 'Verified',
  EXPORTED: 'Exported'
};

// Ticking the header checkbox only ever selects the page you are looking at, so
// the footer offers the rest of the tab. The cap is deliberate: every bulk action
// carries the ids in the request body, and a set nobody can review before sending
// is how the wrong thousand documents get deleted or pushed to the ERP.
export const SELECT_ALL_CAP = 400;

export const selectAllDocuments = {
  SELECT_ALL: 'Select all',
  SELECT_FIRST: 'Select first',
  OF: 'of',
  CLEAR: 'Clear selection',
  SELECTING: 'Selecting\u2026',
  CAPPED_NOTE: `Capped at ${SELECT_ALL_CAP} \u2014 narrow the filter to act on the rest.`,
  FAILED: 'Could not select the other documents. Please try again.'
};

export const tableComponent = {
  CREATED_BY: 'Created By',
  FILE_UPLOADED_BY: 'File Uploaded By',
  MENTIONS: 'Mentions',
  QNA_CREATED_AT: 'Created At',
  EXPORTED_AT: 'Exported At',
  RECIEVED_AT: 'Received At',
  VENDOR_NAME: 'Vendor Name',
  AMOUNT_DUE: 'Amount Due',
  PO_NUMBER: 'PO Number',
  DUE_DATE: 'Due Date',
  DOCUMENT_NAME: 'Document Name',
  DOCUMENT_ID: 'Document ID',
  JOB_ID: 'Job ID',
  EQUIPMENT_NO: 'Equipment No',
  STATUS: 'Status',
  PENDING_DOC: 'Pending',
  ONHOLD_DOC: 'On Hold',
  REJECTED_DOC: 'Rejected',
  IN_REVIEW: 'In Review',
  PROCESSING: 'Processing',
  ERROR_DOC: 'Error',
  VERFIED: 'Verified',
  VERIFIED: 'verified',
  APPROVED_DOC: 'Approved',
  ACTIONS: 'Actions',
  VIEW: 'View',
  TOTAL: 'Total',
  DELETE_DOCUMENT: 'Delete Document',
  DELETE_ATTACHED_DT: 'Attached Delivery ticket cannot be deleted',
  DEATTACH_DT_TO_DELETE: 'Attached delivery ticket cannot be deleted, detach it to proceed.',
  DELETE_DOCUMENT_MESSAGE: 'Are you sure you want to delete this new document',
  QB_INTEGRATION: 'QuickBooks integration is not available',
  SEARCH_NOT_FOUND: 'It appears that the information you’re attempting to find is not available.',
  DOCUMENT_NOT_FOUND: 'There are no documents available. Upload documents to get started',
  APPROVER_DOCUMENT_NOT_FOUND: 'There are no documents available.',
  GENERATE_PO: 'Generate PO',
  SEARCH_ATTACHMENTS: 'Search Attachments to View them',
  SEARCH_CHEQUES: 'No Record',
  INVOICE_NUMBER: 'Document No',
  NO_BATCHES_FOUND: 'There are no documents available',
  NO_OF_INVOICES: 'No of Invoices',
  FILE_NAME: 'File Name',
  SENT_BY: 'Sent By',
  ACTION: 'Action',
  SEND_BY_EMAIL: 'By Email',
  DELETE_SELECTED_DOCUMENTS: 'Are you sure you want to delete selected documents?',
  DELETE_DOCUMENTS: 'Delete Documents',
  DELETE: 'Delete',
  PULL_BACK: 'Pull Back',
  PULL_BACK_MESSAGE: 'Are you sure you want to pull back this document',
  DOCUMENT_DATE: 'Document Date',
  PAYMENT_STATUS: 'Paid',
  DOCUMENT_TYPE: 'Document Type',
  IN_ERP: 'In ERP',
  COMMENT: 'Comment',
  SEND_TO_ERP: 'Send to ERP'
};

// The documents grid's "Reorder Columns" dialog (components/columnOrderModal.jsx).
export const columnOrderText = {
  BUTTON: 'Reorder Columns',
  TITLE: 'Reorder columns',
  INTRO:
    'Drag a column, or use the arrows, to set the order the documents table shows. ' +
    'The order is saved to your profile and applies on every tab.',
  HIDDEN: '(hidden)',
  MOVE_UP: 'Move up',
  MOVE_DOWN: 'Move down',
  DEFAULT_ORDER: 'Default order',
  CANCEL: 'Cancel',
  SAVE: 'Save'
};

export const documentCommentsText = {
  COMMENTS: 'Comments',
  EMPTY_COMMENTS: `Looks like you haven't started a conversation yet`,
  IMAGE_NOT_AVAILABLE: 'Document Image is not Available',
  ERROR_DOWNLOADING_CSV: 'Error downloading the CSV file',
  DOCUMENT_NAME: 'Document Name',
  CREATED_AT: 'Created At',
  FAILED_REASON: 'Failed Reason'
};

export const policyPage = {
  MAX_VALUE_CHECK: 'Max value must be greater than min value or it should be infinity(0)',
  REQUIRED_APPROVALS: 'Required Approvals',
  AUTO_APPROVED: 'Auto Approved',
  APPROVED: 'Approved',
  ADD_POLICY:
    'Initiate the Activation of the Approval Policy to implement a structured review process.',
  DELETE: 'Delete',
  CONFIRM_DELETE_POLICY: 'Are you sure you want to delete the policy?',
  POLICY_LEVEL: 'Levels',
  POLICY_BASIS: 'Policy Basis',
  TOTAL: 'Total',
  VENDOR: 'Vendor',
  JOBID: 'Job Id/ Project Id',
  JOB_TOTAL: 'Job and Total',
  DEFAULT_APPROVER: 'Default Approver',
  DEFAULT_APPROVER_INFO:
    'When the invoice total goes over the threshold, it is also sent to this additional approver at the end.',
  ADD_LEVELS: 'Add Level',
  REMOVE_LEVEL: 'Remove Level',
  POLICY_NOT_ACTIVE: 'Approval Policy is not Active.',
  POLICY_AVAILABLE:
    'Policy creation is available once Manager / C Level registration has been completed..',
  FETCH_MANAGERS: 'Populate Approvers',
  FETCH_APPROVERS_HELPERTEXT: 'Fetch Job id based approvers policy from ERP',
  CONFIRM_FETCH_MANAGERS:
    'This imports your job based approver structure from the ERP and overrides your existing policy levels. Only project managers registered as managers in Beiing Human are added, so register any missing PMs first.',
  POPULATE_APPROVERS_NOTE:
    'To populate the approval policy from your ERP, all your project managers must first be registered as managers in Beiing Human.',
  POLICY_EXISTS_TOOLTIP: 'Policy already exists',
  APPROVAL_POLICY: 'APPROVAL POLICY',
  ACTIVE: 'Active',
  ACTIONS: 'Actions',
  SAVE_POLICY_WARNING:
    'Saving this policy will override your existing policy. Are you sure you want to proceed?',
  CONFIRM_INACTIVE_POLICY:
    'Are you sure you want to make the approval policy inactive? This will disable the approval workflow.'
};

export const manualApprovalPage = {
  CUSTOM_APPROVAL: 'Custom Approval',
  REQUIRED_APPROVAL: 'Required Approvals',
  SELECT_APPROVER: 'Select User from whome you want the Approval',
  SUBMIT: 'Submit',
  NO_APPROVER: ' No Approver Required'
};

export const activity = {
  UPLOADED_BY: 'Document uploaded by ',
  UPDATED_BY: 'Document updated by ',
  APPROVED_BY: 'Document approved by',
  ROTATED_BY: 'Document rotated by',
  REJECT_BY: 'Document rejected by',
  ON_HOLD_BY: 'Document on hold by',
  STATUS: 'Status:',
  CONTENT: 'Content',
  LINEITEM: 'Lineitem',
  ATTACHMENT: 'Attachments',
  DELIVERY_TICKET: 'Supporting Documents',
  CREATED_BY: 'Document created by ',
  COMMENTED_BY: 'Comment by ',
  ATTACHMENT_BY: 'Attachment by ',
  ATTACHMENT_REMOVED_BY: 'Attachment removed by',
  COMMENT: 'Comment',
  EMAIL_SENT: 'Email sent by',
  EMAIL_RECEIVED: 'Email received from',
  QUESTION_BY: 'Question Raised by',
  PULL_BACK_BY: 'Document pulled back by',
  ADDED_TO_QUEUE: 'Document added to queue by',
  ERP_SENT: 'Document sent to erp by',
  DOCUMENT_EXPORTED: 'Document exported by',
  ERP_SEND_FAILED: 'Document failed to send to erp attempted by',
  ASSIGNED_BY: 'Document assigned by ',
  REASSIGNED_BY: 'Document reassigned by ',
  UNASSIGNED_BY: 'Document unassigned by ',
  // Actor shown on an assignment the platform made for itself: those entries are
  // written by the backend's systemActor, so the name slot would read "system".
  AUTOMATIC_ASSIGNMENT: 'Automatic assignment',
  ASSIGNMENT: 'Assignment',
  ASSIGNED_TO: 'Assigned to',
  PREVIOUSLY_ASSIGNED_TO: 'Previously assigned to',
  ASSIGNMENT_MODE: 'Mode',
  NO_ASSIGNEE: 'No one',
  // Custom folders (see utils/customFolders.js).
  MOVED_TO_FOLDER_BY: 'Document moved to folder by ',
  REMOVED_FROM_FOLDER_BY: 'Document removed from folder by ',
  FOLDER: 'Folder',
  MOVED_TO: 'Moved to',
  MOVED_FROM: 'Moved from',
  // Documents-list Note (see utils/documentNote.js).
  NOTE_ADDED_BY: 'Note added by ',
  NOTE_UPDATED_BY: 'Note updated by ',
  NOTE_CLEARED_BY: 'Note cleared by ',
  NOTE: 'Note',
  PREVIOUS_NOTE: 'Previous note',
  NO_NOTE: 'None'
};

export const dashboardText = {
  AVERAGE_TIME: 'Average approval time per document',
  TIME: 'AVG Time:',
  MINUTES: 'Minutes',
  AVERAGE_CHANGES: 'Average changes per document',
  CHANGES: 'AVG Changes:',
  CHANGE: 'Changes',
  VENDOR_DOCUMENTS: 'Documents by  Vendor',
  AMOUNT_DOCUMENTS: 'Documents by  Amount ($)',
  AGING_DOCUMENTS: 'Documents by Aging',
  AGING_TOTAL: 'Total by Aging ($)',
  JOBID_DOCUMENTS: 'Documents by Job ID',
  COSTID_DOCUMENTS: 'Documents by Cost ID',
  RECORD_NOT_FOUND: 'No records were found associated with this filter.',
  DOCUMENT_STATUS_RATIO: 'Documents by Error Ratio and Success Ratio',
  DOC_TYPE: 'Documents by Type',
  RESPONSE_TIME: 'Response Time by Each Document',
  RECORD_NOT_FOUND: 'No Data Found',
  TOTAL_DOCUMENTS: 'Total Documents : '
};

export const duplicateDoc = {
  DUPLICATE_DOC: 'Duplicate Document',
  CANCEL: 'Cancel',
  CONTINUE: 'Submit',
  PREVIOUS: 'Previous',
  NEW: 'New',
  DELETE: 'Delete',
  DOCUMENT_IMAGE_NOT_FOUND: 'Document file not found'
};

export const unauthorizedPage = {
  UNAUTHORIZED: 'Unauthorized Access',
  UNAUTHORIZED_INFORMATION:
    'Oops! You do not have permission to view this page. It looks like you might not be authorized to access this content. If you believe this is an error, please check with your administrator or the person in charge.',
  SOMETHING_WRONG: 'Oops! Something Went Wrong',
  REFRESH_PAGE:
    'Either refresh the page or return home to try again and if the issue still exists ,  please check with Beiing Human.'
};

export const documentTypes = {
  ESTIMATE: 'Estimate',
  DELIVERY_TICKET: 'DeliveryTicket',
  INVOICE: 'Invoice',
  G702: 'G702',
  RECEIPT: 'Receipt',
  PURCHASE_ORDER: 'Po'
};

export const documentConfiguration = {
  TAB_SETTINGS: 'Settings',
  TITLE: 'Document Configuration',
  DESCRIPTION: 'Choose which custom fields appear on each document type.',
  SAVE_BUTTON: 'Save Configuration',
  COLUMN_DOC_TYPE: 'Document Type',
  COLUMN_FIELDS: 'Custom Fields',
  SELECT_FIELDS: 'Select fields',
  NO_FIELDS_AVAILABLE: 'No custom fields found for your ERP. Sync your integration to load fields.',
  SAVE_SUCCESS: 'Document configuration saved.',
  SAVE_ERROR: 'Failed to save document configuration.',
  // value matches the get/update-configuration payload keys exactly
  DOC_TYPE_OPTIONS: [
    { value: 'invoice', label: 'Invoice' },
    { value: 'receipt', label: 'Receipt' },
    { value: 'g702', label: 'G702' },
    { value: 'estimate', label: 'Quote' },
    { value: 'deliveryTicket', label: 'Delivery Ticket' },
    { value: 'po', label: 'Purchase Order' }
  ]
};
export const fieldsConfiguration = {
  TITLE: 'Document Configurations',
  // The avatar menu sits next to short labels (Users, FAQ), so it uses the short form.
  MENU_LABEL: 'Configurations',
  DESCRIPTION:
    'Turn fields on or off for your company. A disabled field stops being captured and stops showing on the document — on every document type that carries it.',
  SAVE_BUTTON: 'Save Changes',
  RESET_BUTTON: 'Discard',
  SEARCH_PLACEHOLDER: 'Search fields',
  UNSAVED: 'Unsaved changes',
  ENABLE_ALL: 'Enable all',
  DISABLE_ALL: 'Disable all',
  APPEARS_ON: 'Appears on',
  ALL_DOC_TYPES: 'All documents',
  // Past three the names stop fitting the card; the tooltip still lists them all.
  MANY_DOC_TYPES: 'document types',
  NO_FIELDS: 'No fields are configured for your ERP.',
  NO_MATCHES: 'No fields match your search.',
  SAVE_SUCCESS: 'Document configuration saved.',
  SAVE_ERROR: 'Failed to save document configuration.',
  LOAD_ERROR: 'Failed to load document configuration.',
  // The PUT accepts a locked row instead of failing, and hands it back in
  // ignoredFields. The UI disables those switches, so this only fires if the BE
  // locked something after the page was loaded.
  IGNORED_NOTICE: 'Some fields could not be changed:',
  LOCKED_DEFAULT: 'This field cannot be turned off.',
  LOCK_REASONS: {
    REQUIRED: 'Required — this field is always captured.'
  },
  // A coding code is one setting shared by the coding block and the line items
  // table: the BE applies `{ name: 'userJobId', enabled: false }` to both lists.
  // The two switches move together so they can never disagree on screen.
  LINKED_GROUPS: ['codes', 'lineItems'],
  LINKED_HINT: 'One setting — this code is shared with the line items table.',
  // Fields that are one decision rather than several. A discount with no discount date
  // (or the reverse) is not a state a document can be in; work order and scope are a
  // Vista pair that the rest of the app already treats as one — the work-order flag
  // adds and removes both together, and every Vista line type either requires both or
  // disallows both. So their switches move together here too.
  LINKED_FIELDS: [
    ['discount', 'discount_date'],
    ['workOrder', 'scope']
  ],
  LINKED_FIELD_HINT: 'Moves together with',
  // This screen names the field, the canvas names the column it fills. replaceName
  // calls glDivision "Division 1" because that is its position on the coding row;
  // here, where you are switching the field itself on and off, it needs its own name.
  LABEL_OVERRIDES: {
    glDivision: 'Gl Division'
  },
  // key matches the get/update-document-field-configuration bucket names exactly
  FIELD_GROUPS: [
    {
      key: 'content',
      label: 'Content Fields',
      description: 'Header-level values read off the document.',
      accent: '#14b8a6'
    },
    {
      key: 'lineItems',
      label: 'Line Item Fields',
      description: 'Columns available on the line items table.',
      accent: '#6366f1'
    },
    {
      key: 'codes',
      label: 'Coding Fields',
      description: 'Coding values used when the document is distributed.',
      accent: '#f59e0b'
    },
    {
      key: 'paymentDetails',
      label: 'Payment Fields',
      description: 'Payment details recorded against the document.',
      accent: '#ec4899'
    }
  ],
  // A GET can list the enabled rows first and append the switched-off ones, which
  // would send a field to the bottom of its group the moment it was turned off.
  // These lists pin the display order instead; a name they don't cover keeps its
  // API order behind the ones they do. `content` names are the canonical ones —
  // `date`, not the per-document-type aliases it carries.
  FIELD_ORDER: {
    content: [
      'vendor',
      'date',
      'number',
      'total',
      'due_date',
      'purchase_order',
      'tax',
      'tax_code',
      'tax_type',
      'payment_terms',
      'freight',
      'miscellaneous_amount',
      'shipping_address',
      'discount',
      'discount_date',
      'transaction_date',
      'notes',
      // The invoice's retainage is a PERCENTAGE now, exactly as the pay
      // application's is — `retainage_amount` was a dollar box a customer typed
      // "10" into meaning ten percent, and whose value reached no ERP at all.
      // Listed read-only (the backend resolves it required, Foundation only).
      'retainage_percentage',
      // What is left once that rate is withheld. Derived from the total and the
      // rate, read-only on the canvas, and read-only here too — it is an answer,
      // not a choice. Same scope as the rate it comes from.
      'current_payment_due'
    ],
    // Mirrors `preferredOrder` in constants/utils.js, which canvas and the details
    // drawer both build their columns from — the table and this screen agree on the
    // sequence because they read the same one.
    lineItems: [
      'Product_Code',
      'Description',
      'Quantity',
      'UOM',
      'Unit_Price',
      'Amount',
      'tax',
      'tax_code',
      'tax_type',
      'miscellaneous_amount',
      'discount',
      'type',
      'itemReference',
      'GlAccount',
      // Acumatica's GL subaccount — offered to Acumatica companies only.
      'subaccount',
      'glPeriod',
      'userJobId',
      'workOrder',
      'scope',
      'userPhases',
      'userCostId',
      'userCostType',
      'equipmentNo',
      'serviceCode',
      'glDivision',
      'division2',
      'division3',
      'division4'
    ],
    // Doubles as the routing table for the ERP-aware labeller: a name here is titled
    // by replaceName (Work Order, Cost Code, Item), everything else by
    // replaceContentNames. Keep a new code type in both this list and the ERP's.
    codes: [
      'type',
      'itemReference',
      'GlAccount',
      // Acumatica's GL subaccount — offered to Acumatica companies only.
      'subaccount',
      'glPeriod',
      'userJobId',
      'workOrder',
      'scope',
      'userPhases',
      'userCostId',
      'userCostType',
      'equipmentNo',
      'serviceCode',
      'glDivision',
      'division2',
      'division3',
      'division4'
    ],
    paymentDetails: ['payment_status', 'payment_type', 'check_no', 'payment_amount', 'payment_date']
  }
};

export const erpTypes = {
  FOUNDATION_ERP: 'Foundation',
  VIEWPOINT_VISTA_ERP: 'viewPointVista',
  VIEWPOINT_SPECTRUM_ERP: 'viewPointSpectrum',
  QUICKBOOKS_DESKTOP_ERP: 'QuickBooksDesktop',
  QUICKBOOKS_ONLINE_ERP: 'QuickBooksOnline',
  DELTEK_COMPUTEREASE_ERP: 'DeltekComputerEase',
  ACUMATICA_ERP: 'Acumatica'
};
// What each ERP is called on screen. The stored values are camelCase keys, which
// is not what a customer calls their accounting system — a message naming the
// ERP has to use the name they know.
export const ERP_LABELS = {
  [erpTypes.FOUNDATION_ERP]: 'Foundation',
  [erpTypes.VIEWPOINT_VISTA_ERP]: 'Vista',
  [erpTypes.VIEWPOINT_SPECTRUM_ERP]: 'ViewPoint Spectrum',
  [erpTypes.QUICKBOOKS_DESKTOP_ERP]: 'QuickBooks Desktop',
  [erpTypes.QUICKBOOKS_ONLINE_ERP]: 'QuickBooks Online',
  [erpTypes.DELTEK_COMPUTEREASE_ERP]: 'Deltek Computer Ease',
  [erpTypes.ACUMATICA_ERP]: 'Acumatica',
  AccountingSeed: 'Accounting Seed',
  Other: 'Other'
};

// ERPs that sync a pay control (BE key: accountant) per vendor, so the documents
// table can show/filter the Pay Control column for them.
export const PAY_CONTROL_ERPS = [erpTypes.VIEWPOINT_VISTA_ERP, erpTypes.FOUNDATION_ERP];

// ERPs whose documents-list Send to ERP (header bulk button + per-row send icon) is
// hidden for now. Remove an ERP from here to bring the button back.
export const SEND_TO_ERP_HIDDEN_ERPS = [erpTypes.FOUNDATION_ERP];

// Companies that keep Send to ERP even though their ERP is in SEND_TO_ERP_HIDDEN_ERPS,
// keyed by Environment because company ids belong to one environment's database.
const SEND_TO_ERP_ENABLED_COMPANY_IDS = {
  Production: ['656c6c4972dbf553d253d5b9', '6a68a1cfae961bed1c0ad55d', '66183fc4b2807f81a3573963']
};

// What a Foundation direct-write company (company.useFoundationDirect) can send
// as an AP voucher: an invoice, or a receipt as a prepaid voucher. Mirrors the
// backend's FOUNDATION_AP_DOCUMENT_TYPES less G702, which is not offered yet.
export const FOUNDATION_DIRECT_AP_DOCUMENT_TYPES = [documentTypes.INVOICE, documentTypes.RECEIPT];

// Which documents a Foundation company can send from the documents list: a PO
// always (legacy and direct), an invoice or receipt only on a direct-write company.
export const isFoundationSendableDocument = (documentType, useFoundationDirect) =>
  documentType === documentTypes.PURCHASE_ORDER ||
  (!!useFoundationDirect && FOUNDATION_DIRECT_AP_DOCUMENT_TYPES.includes(documentType));

export const isSendToErpHidden = (erpType, companyId) =>
  SEND_TO_ERP_HIDDEN_ERPS.includes(erpType) &&
  !(SEND_TO_ERP_ENABLED_COMPANY_IDS[Environment] || []).includes(String(companyId));

export const attachmentPage = {
  CONNECT_ERP: 'Connect your erp to get vendors list',
  NO_DOCUMENTS: 'No Documents',
  SELECTED_DOCUMENTS: 'Queue',
  ERROR: 'Documents not selected',
  SEARCH_DOCUMENTS: 'Search Document',
  LOADING: 'Loading...',
  NO_ATTACHMENTS: 'No Attachments',
  ATTACHMENTS: 'Upload Attachments'
};

export const foundationConstructionCompanySyncArray = [
  { name: 'Vendors', value: ['vendors'] },
  { name: 'Accounts', value: ['accounts'] },
  { name: 'Job Ids', value: ['jobIds'] },
  // Foundation shows Cost Id as "Cost Code" on the UI; BE key (costIds) unchanged.
  { name: 'Cost Codes', value: ['costIds'] },
  { name: 'Cost Types', value: ['costType'] },
  { name: 'Terms', value: ['termsList'] },
  { name: 'Paid Invoices', value: ['paid'] },
  { name: 'Divisions', value: ['glDivision'] },
  { name: 'In ERP', value: ['sendErpStatus'] },
  { name: 'UOM', value: ['uom'] },
  {
    name: 'All',
    value: [
      'vendors',
      'accounts',
      'jobIds',
      'costIds',
      'costType',
      'employees',
      'termsList',
      'glDivision',
      'serviceCode',
      'equipment',
      'sendErpStatus',
      'uom'
    ]
  }
];

// Deltek ComputerEase through the BH connector. Phase, Purchase Order and
// Subcontract are added by applyPhasePermission / applyPoMatchPermission.
export const deltekComputerEaseSyncArray = [
  { name: 'Vendors', value: ['vendors'] },
  { name: 'Accounts', value: ['accounts'] },
  { name: 'Job Ids', value: ['jobIds'] },
  { name: 'Cost Codes', value: ['costIds'] },
  { name: 'Cost Types', value: ['costType'] },
  { name: 'Equipment No', value: ['equipment'] },
  { name: 'Work Order', value: ['workOrder'] },
  { name: 'Tax Codes', value: ['taxCode'] },
  { name: 'UOM', value: ['uom'] },
  {
    name: 'All',
    value: [
      'vendors',
      'accounts',
      'jobIds',
      'costIds',
      'costType',
      'equipment',
      'workOrder',
      'taxCode',
      'uom'
    ]
  }
];

export const OtherConstructionCompanySyncArray = [
  { name: 'Vendors', value: ['vendors'] },
  { name: 'Accounts', value: ['accounts'] },
  { name: 'Job Ids', value: ['jobIds'] },
  { name: 'Items', value: ['costIds'] },
  { name: 'Cost Types', value: ['costType'] },
  {
    name: 'All',
    value: ['vendors', 'accounts', 'jobIds', 'costIds', 'costType']
  }
];
export const foundationSyncArray = [
  { name: 'Vendors', value: ['vendors'] },
  { name: 'Accounts', value: ['accounts'] },
  { name: 'In ERP', value: ['sendErpStatus'] },
  { name: 'Paid Invoices', value: ['paid'] },
  { name: 'UOM', value: ['uom'] },
  { name: 'Divisions', value: ['glDivision'] },
  { name: 'Terms', value: ['termsList'] },
  {
    name: 'All',
    value: ['vendors', 'accounts', 'paid', 'sendErpStatus', 'uom', 'glDivision', 'termsList']
  }
];
export const otherSyncArray = [
  { name: 'Vendors', value: ['vendors'] },
  { name: 'Accounts', value: ['accounts'] },
  { name: 'All', value: ['vendors', 'accounts'] }
];
export const vistaConstructionData = [
  { name: 'Vendors', value: ['vendors'] },
  { name: 'Accounts', value: ['accounts'] },
  { name: 'Job Ids', value: ['jobIds'] },
  // VP Vista shows Cost Id as "Cost Code" on the UI; BE key (costIds) unchanged.
  { name: 'Cost Codes', value: ['costIds'] },
  { name: 'Cost Types', value: ['costType'] },
  { name: 'ERP Company', value: ['erpCompany'] },
  { name: 'Tax Codes', value: ['taxCode'] },
  // [reviewer-disabled] not needed yet — kept for later (only Reviewer Group is used for now)
  // { name: 'Reviewers', value: ['reviewer'] },
  { name: 'Reviewer Groups', value: ['reviewerGroup'] },
  { name: 'Departments', value: ['smDepartment', 'jcDepartment'] },
  { name: 'UOM', value: ['uom'] },
  { name: 'Custom Fields', value: ['customField'] },
  {
    name: 'All',
    value: [
      'vendors',
      'accounts',
      'jobIds',
      'costIds',
      'costType',
      'employees',
      'erpCompany',
      'taxCode',
      'termsList',
      // [reviewer-disabled] 'reviewer',
      'reviewerGroup',
      'smDepartment',
      'jcDepartment',
      'uom',
      'customField',
      'POCompanyParams'
    ]
  }
];
export const vistaBasicData = [
  { name: 'Vendors', value: ['vendors'] },
  { name: 'Accounts', value: ['accounts'] },
  { name: 'ERP Company', value: ['erpCompany'] },
  { name: 'Tax Codes', value: ['taxCode'] },
  // [reviewer-disabled] not needed yet — kept for later (only Reviewer Group is used for now)
  // { name: 'Reviewers', value: ['reviewer'] },
  { name: 'Reviewer Groups', value: ['reviewerGroup'] },
  { name: 'Departments', value: ['smDepartment', 'jcDepartment'] },
  { name: 'UOM', value: ['uom'] },
  { name: 'Custom Fields', value: ['customField'] },
  {
    name: 'All',
    value: [
      'vendors',
      'accounts',
      'employees',
      'erpCompany',
      'taxCode',
      'termsList',
      // [reviewer-disabled] 'reviewer',
      'reviewerGroup',
      'smDepartment',
      'jcDepartment',
      'uom',
      'customField',
      'POCompanyParams'
    ]
  }
];
export const spectrumBasicData = [
  { name: 'Vendors', value: ['vendors'] },
  { name: 'Accounts', value: ['accounts'] },
  { name: 'ERP Company', value: ['erpCompany'] },
  { name: 'UOM', value: ['uom'] },
  { name: 'Terms', value: ['termsList'] },
  {
    name: 'All',
    value: ['vendors', 'accounts', 'employees', 'erpCompany', 'uom', 'termsList']
  }
];
export const spectrumConstructionData = [
  { name: 'Vendors', value: ['vendors'] },
  { name: 'Accounts', value: ['accounts'] },
  { name: 'Job Ids', value: ['jobIds'] },
  { name: 'Cost Ids', value: ['costIds'] },
  { name: 'Cost Types', value: ['costType'] },
  { name: 'ERP Company', value: ['erpCompany'] },
  { name: 'UOM', value: ['uom'] },
  { name: 'Terms', value: ['termsList'] },
  {
    name: 'All',
    value: [
      'vendors',
      'accounts',
      'jobIds',
      'costIds',
      'costType',
      'employees',
      'erpCompany',
      'uom',
      'termsList'
    ]
  }
];
// Acumatica through the ERP layer, in Acumatica's own words (Project, Cost Code,
// Account Group). Task, Purchase Order and Subcontract are added by
// applyPhasePermission / applyPoMatchPermission. Budgets go as `jobPhases`, the
// spelling the sync-files validator accepts.
export const acumaticaSyncArray = [
  { name: 'Vendors', value: ['vendors'] },
  { name: 'Accounts', value: ['accounts'] },
  { name: 'Subaccounts', value: ['subaccount'] },
  { name: 'Projects', value: ['jobIds'] },
  { name: 'Cost Codes', value: ['costIds'] },
  { name: 'Account Groups', value: ['costType'] },
  { name: 'Budgets', value: ['jobPhases'] },
  { name: 'Employees', value: ['employees'] },
  { name: 'Terms', value: ['termsList'] },
  { name: 'UOM', value: ['uom'] },
  { name: 'Branches', value: ['erpCompany'] },
  { name: 'In ERP', value: ['sendErpStatus'] },
  { name: 'Paid Invoices', value: ['paid'] },
  {
    name: 'All',
    value: [
      'vendors',
      'accounts',
      'subaccount',
      'jobIds',
      'costIds',
      'costType',
      'jobPhases',
      'employees',
      'termsList',
      'uom',
      'erpCompany'
    ]
  }
];
function addServiceAndEquipmentToAll(data, serviceAndEquipmentPermission) {
  if (!serviceAndEquipmentPermission) return data;

  return data?.map((item) =>
    item?.name === 'All'
      ? {
          ...item,
          value: Array.from(new Set([...item?.value, 'serviceCode', 'equipment']))
        }
      : item
  );
}

// The manual-sync dropdown. Its options are coarse groups rather than one entry per
// field, so it asks the two coarse questions the retired construction-company and
// service-code/equipment flags used to answer — but asks them of the field
// configuration, via codesJobsAndCosts / codesServiceOrEquipment.
export function getSyncDropdownOptions(
  isConstructionCompany,
  erpType,
  serviceAndEquipmentPermission
) {
  let syncArray = [];
  switch (erpType) {
    case 'Foundation': {
      if (isConstructionCompany) {
        syncArray = serviceAndEquipmentPermission
          ? addServiceAndEquipmentToAll(
              [
                { name: 'Equipment No', value: ['equipment'] },
                { name: 'Service Codes', value: ['serviceCode'] },
                ...foundationConstructionCompanySyncArray
              ],
              true
            )
          : [...foundationConstructionCompanySyncArray];
      } else {
        syncArray = serviceAndEquipmentPermission
          ? addServiceAndEquipmentToAll(
              [
                { name: 'Equipment No', value: ['equipment'] },
                { name: 'Service Codes', value: ['serviceCode'] },
                ...foundationSyncArray
              ],
              true
            )
          : [...foundationSyncArray];
      }
      break;
    }

    case 'viewPointVista': {
      if (isConstructionCompany) {
        syncArray = serviceAndEquipmentPermission
          ? addServiceAndEquipmentToAll(
              [
                { name: 'Equipment No', value: ['equipment'] },
                { name: 'Service Codes', value: ['serviceCode'] },
                { name: 'Terms', value: ['termsList'] },
                ...vistaConstructionData
              ],
              true
            )
          : [...vistaConstructionData];
      } else {
        syncArray = serviceAndEquipmentPermission
          ? addServiceAndEquipmentToAll(
              [
                { name: 'Equipment No', value: ['equipment'] },
                { name: 'Service Codes', value: ['serviceCode'] },
                { name: 'Terms', value: ['termsList'] },
                ...vistaBasicData
              ],
              true
            )
          : [...vistaBasicData];
      }
      break;
    }
    case 'viewPointSpectrum': {
      if (isConstructionCompany) {
        syncArray = serviceAndEquipmentPermission
          ? addServiceAndEquipmentToAll(
              [
                { name: 'Equipment No', value: ['equipment'] },
                { name: 'Service Codes', value: ['serviceCode'] },
                ...spectrumConstructionData
              ],
              true
            )
          : [...spectrumConstructionData];
      } else {
        syncArray = serviceAndEquipmentPermission
          ? addServiceAndEquipmentToAll(
              [
                { name: 'Equipment No', value: ['equipment'] },
                { name: 'Service Codes', value: ['serviceCode'] },

                ...spectrumBasicData
              ],
              true
            )
          : [...spectrumBasicData];
      }
      break;
    }
    case 'DeltekComputerEase': {
      syncArray = [...deltekComputerEaseSyncArray];
      break;
    }
    case 'Acumatica': {
      syncArray = [...acumaticaSyncArray];
      break;
    }
    default: {
      syncArray = isConstructionCompany
        ? [...OtherConstructionCompanySyncArray]
        : [...otherSyncArray];
      break;
    }
  }

  return syncArray;
}

export const DeltekConnectorPopup = {
  TITLE: 'Deltek ComputerEase connector',
  INTRO:
    'The connector is a small Windows program for the computer that runs ComputerEase. ' +
    'It finds your ComputerEase data on its own, sends your codes to Beiing Human every 10 minutes and enters approved invoices in ComputerEase as unposted vouchers.',
  STEP_1: '1. Download the connector program',
  STEP_2: '2. Download your config file',
  STEP_2_NOTE:
    'The config file identifies your company. Downloading a new one disconnects any connector using the old one.',
  STEP_3:
    '3. On the ComputerEase computer, keep both files in the same folder (or in Downloads) and double-click BH-Deltek-Connector.exe. ' +
    'If Windows shows "Windows protected your PC", choose More info → Run anyway.',
  DOWNLOAD_PROGRAM: 'Download connector',
  DOWNLOAD_CONFIG: 'Download config file',
  COMPANY_NUMBER: 'ComputerEase company number (optional)',
  COMPANY_NUMBER_HINT:
    'If this computer has more than one ComputerEase company, enter the one to connect (for example 2). Leave it empty and the connector will ask on that computer.',
  DOWNLOAD_TEST_PROGRAM: 'Download test connector',
  TEST_NOTE: 'Test connector (not shown on production): uses built-in fake ComputerEase companies instead of a real ComputerEase.'
};
export const QueuePopup = {
  USER_QUEUE: 'User Queue',
  NO_RECORD: 'No Record',
  PROGRESS: 'In Progress',
  PENDING: 'Pending',
  NO_PENDING_TASK: 'No pending tasks',
  CLEAR_QUEUE: 'Clear Queue',
  QUEUE_MESSAGE: 'Are you sure you want to clear the queue?'
};

export const LearnMoreLink = 'https://beiinghuman.com/quickbooks-integration/';
export const DisconnectLink = 'https://beiinghuman.com/quickbooks-disconnected/';

export const supportingDocumentsPopup = {
  NO_DOCUMENTS:
    'There are no attached delivery tickets to this invoice. Please attach a delivery ticket first',
  INVOICE_LINEITEMS: 'LineItems',
  NO_LINEITEMS: 'No Line Items',
  DESCRIPTION: 'Description',
  QUANTITY: 'Quantity',
  // The commitment fetched into this view can be either a purchase order or a
  // subcontract — get-document-by-erp falls back to subcontracts and does not
  // report which kind matched — so every heading in the PO column names both.
  NO_PO: 'PO/SC Not Found',
  PO_LINEITEMS: 'PO/SC LineItems',
  PO_TAB: 'PO/SC',
  COMPARE_PO: 'Compare PO/SC to Invoice',
  COMPARE_DT: 'Compare Delivery Ticket to Invoice',
  SUPPORTING_DOCUMENT: 'Supporting Document',
  // Matches the canvas's own label for the purchase_order field
  // (replaceContentNames) and keeps the card header from wrapping.
  PO_CARD_TITLE: 'PO/ Subcontract',
  // The PO line table carries Received and Remaining TWICE — once as the ERP
  // reports them and once as Beiing Human has consumed them — so the pair is
  // grouped under a heading that says which side it is. Without that, "BH
  // Received" sitting beside "Received" reads as one running-on heading, which
  // is exactly how it looked. See poLineitems for why the two are never merged.
  ERP_COLUMN_GROUP: 'In ERP',
  BH_COLUMN_GROUP: 'In Beiing Human',
  STATUS: 'Status',
  AMOUNT: 'Amount',
  REMAINING: 'Remaining',
  RECIEVED: 'Received',
  INVOICE: 'Invoice',
  SHOW_INVOICE: 'Switch to Invoice',
  SHOW_LINEITEMS: 'Switch to LineItems'
};

export const attachDeliveryTicketPage = {
  DELIVERY_TICKET: 'Delivery Tickets',
  ATTACH_DELIVERY_TICKET: 'Attached Delivery Tickets',
  NO_DT: 'No Delivery Tickets Attached',
  NO_DT_FOUND: 'No Delivery Tickets Found',
  NO_SUGGESTED_DT: 'No Suggested Delivery Tickets',
  DT_SUGGESTION_CRITERIA:
    'Invoice No cannot be empty, Vendor must match and delivery ticket date must be same or earlier than document date.',
  SUGGESTED_DELIVERY_TICKET: 'Suggested Delivery Tickets',
  SHOW_ALL_DT: 'Show All Delivery Tickets',
  ALL_DELIVERY_TICKETS: ' All Delivery Tickets'
};

export const poInvoicesPage = {
  HEADING: 'Purchase Order vs Invoices',
  PURCHASE_ORDER: 'Purchase Order',
  INVOICES: 'Invoices',
  INVOICE_PREVIEW: 'Invoice Preview',
  INVOICE_NOT_FOUND: 'No Invoices found for this PO',
  NO_RESPONSE: 'No Result Found',
  // The same popup now also resolves SUBCONTRACTS — the backend reports which
  // kind matched as `recordType`, so the headings can say so exactly rather than
  // settling for a neutral "PO/SC" the way the read-only compare modal has to.
  HEADING_SUBCONTRACT: 'Subcontract vs Invoices',
  SUBCONTRACT: 'Subcontract',
  INVOICE_NOT_FOUND_SUBCONTRACT: 'No Invoices found for this Subcontract'
};

// The ERP's own position on a commitment, shown beside what Beiing Human has
// itself approved. Deliberately two labelled figures and not one blended number:
// the two invoice sets overlap without containing each other (some invoices are
// posted straight into the ERP and we never see them; some are approved here and
// not yet posted), so adding them double-counts and picking one hides real money.
export const commitmentPosition = {
  ERP_REMAINING: 'Remaining in ERP',
  ERP_RECEIVED: 'Invoiced in ERP',
  ERP_RETAINAGE: 'Retainage withheld',
  BH_REMAINING: 'Remaining per Beiing Human',
  BH_RECEIVED: 'Consumed in Beiing Human',
  // Change orders: the ERP header is the ORIGINAL contract, and the remaining
  // figures above are measured against original + change orders.
  ORIGINAL_CONTRACT: 'Original contract',
  CHANGE_ORDERS: 'Change orders',
  REVISED_CONTRACT: 'Revised contract',
  // changeOrdersUnavailable is a genuine gap: the change-order table could not
  // be read at all, so a real change order may be missing from the figures
  // above. lineSumExceedsRevised is NOT a gap any more — the backend now
  // folds Foundation's detail-line total into Revised contract / Remaining
  // whenever it exceeds header + synced change orders, so this note only
  // explains why Revised contract is higher than Original + the change orders
  // line shown above it.
  CHANGE_ORDERS_UNAVAILABLE:
    'Change orders could not be read from Foundation, so this may not include them.',
  LINE_SUM_EXCEEDS:
    "Includes value already reflected in Foundation's own detail lines.",
  CHANGE_ORDER_TAG: 'Change order',
  NOT_KNOWN: '—',
  AS_OF: 'as of',
  // Why a figure could not be produced. Shown instead of a number, never as a 0:
  // "nothing has been invoiced" and "nobody managed to look" are different
  // answers, and only one of them is safe to act on.
  REASONS: {
    ledgerNeverSynced: 'ERP invoice history has not synced yet',
    outsideLedgerWindow: 'Commitment predates the synced invoice history',
    unpricedRows: 'Some ERP invoices carry no amount',
    noTotal: 'This commitment has no total amount',
    lookupFailed: 'Could not read the ERP invoice history'
  }
};

export const gaTrackingId = 'G-W6FYYKYMQ9';

export const hotJarSiteId = '5254770';

export const commentsInput = {
  COMMENT_PLACEHOLDER: 'Type your comment here...',
  SEND: 'Send',
  ATTACH: 'Attach',
  ADD_COMMENT: 'Add Comment',
  ATTACHMENT_MESSAGE: 'Drop your attachment here, or click to browse',
  COMMENT: 'Comment',
  QUESTION: 'Question',
  QUESTION_MESSAGE: 'Type your question here...',
  RESOLVE: 'Resolve'
};

export const voiceNote = {
  RECORD: 'Record a voice note',
  STOP: 'Stop recording',
  DISCARD: 'Discard this recording',
  PROMPT: 'Record a voice note',
  RECORDING: 'Recording',
  RECORDED: 'Voice note ready',
  DELETE: 'Delete voice note',
  PLAY: 'Play',
  PAUSE: 'Pause',
  PLAYBACK_SPEED: 'Playback speed',
  DOWNLOAD: 'Download',
  DELETED_BY: 'Voice note deleted by',
  DELETED: 'Voice note deleted',
  // Matches the backend's fallback text for a comment posted with a recording
  // and nothing typed, so the body is not shown twice.
  ONLY_TEXT: 'Voice note',
  // Title + description + buttons of the app's own Prompt modal, the same shape
  // every other destructive confirmation here uses (Delete User, Delete Policy).
  CONFIRM_TITLE: 'Delete Voice Note',
  CONFIRM_DELETE: 'Are you sure you want to delete this voice note? This action cannot be undone.',
  CONFIRM_CANCEL: 'Cancel',
  CONFIRM_ACCEPT: 'Delete',
  DELETE_FAILED: 'Could not delete the voice note. Please try again.',
  UNSUPPORTED: 'Recording is not supported in this browser.',
  PERMISSION_DENIED: 'Microphone access was blocked. Allow it in your browser to record.',
  MIC_UNAVAILABLE: 'No microphone is available.',
  EMPTY_RECORDING: 'Nothing was recorded. Please try again.',
  // Server caps bytes at 10MB; this caps length, which is what a person notices.
  MAX_SECONDS: 300
};

export const exportBatches = {
  CREATED_AT: 'Created At',
  NO_OF_DOCUMENTS: 'No. Documents',
  BATCH_NAME: 'Batch Name',
  GENERATED_BY: 'Generated By',
  UPDATED_AT: 'Updated At',
  STATUS: 'Status',
  GENERATED: 'Generated',
  PROCESSING: 'Processing',
  ERROR: 'Error',
  ACTIONS: 'Actions',
  REGENERATE: 'Regenerate',
  DOWNLOAD: 'Download',
  BATCH_DOCUMENTS: 'Batch Documents',
  BATCH_MESSAGE: 'No documents found in this batch',
  DOWNLOADED: 'Downloaded',
  IN_ERP: 'In Erp'
};

export const advanceSearchFields = {
  INVOICE_NUM: 'Document Number',
  SEARCH_FOR: 'Search For',
  VENDOR: 'Vendor',
  JOB_ID: 'Job Id',
  COST_ID: 'Cost Id',
  PHASE: 'Phase',
  COST_TYPE: 'Cost Type',
  GL_ACCOUNT: 'GL Account',
  PURCHASE_ORDER: 'Purchase Order',
  AMOUNT: 'Total',
  DOCUMENT_DATE: 'Document Date',
  RECEIPT_DATE: 'Receipt Date',
  DUE_DATE: 'Due Date',
  DOCUMENT_DATE: 'Document Date',
  CREATED_AT: 'Created At',
  UPDATED_AT: 'Updated At',
  STATUS: 'Status',
  CURRENT_OWNER: 'Current Owner',
  CATEGORY: 'Category',
  BY_EMAIL: 'By Email',
  SORT: 'Sort',
  OLD_TO_NEW: 'Old to New',
  NEW_TO_OLD: 'New to Old',
  SEARCH: 'Search',
  PAYMENT_STATUS: 'Payment Status',
  EQUIPMENT_NUMBER: 'Equipment Number',
  SERVICE_CODE: 'Service Code',
  CLEAR: 'Clear',
  SELECT_AND_SEARCH: 'Select Options and Click "Search"',
  KEYWORD: 'Includes the Words',
  DUE_DATE: 'Due Date'
};

export const searchStatusOptions = [
  'APPROVED',
  'PENDING',
  'ON_HOLD',
  'ERROR',
  'DUPLICATE',
  'ATTACHED',
  'PROCESSING',
  'IN_REVIEW',
  'REJECTED',
  'IN_ERP',
  'In_Q&A'
];

export const activityPage = {
  ATTACHMENT: 'Attachments:',
  INVALID_ATTACHMENT: 'Invalid Attachments:',
  REASON: 'Reason:'
};

/**
 * How long after posting a comment its author may still edit the text.
 *
 * MIRRORS `constants.COMMENT_EDIT_WINDOW_MS` in the backend's
 * `api/utilities/constants.ts`. The server is the authority — it answers 422 to
 * a PATCH that arrives late — so this only decides whether the affordance is
 * offered at all. The two must be changed together: a longer window here offers
 * an edit the API refuses, a shorter one hides an edit the API would accept.
 */
export const COMMENT_EDIT_WINDOW_MS = 60 * 60 * 1000; // 1 hour

// The author's inline edit of their own comment, in the activity feed.
export const commentEdit = {
  EDIT_LABEL: 'Edit comment',
  INPUT_LABEL: 'Edit comment text',
  EDITED: '(edited)',
  SAVE: 'Save',
  SAVING: 'Saving...',
  CANCEL: 'Cancel',
  // Mirrors the backend's Joi schema for edit-comment: trimmed, min 1, max 1000.
  MAX_LENGTH: 1000,
  TOO_LONG: 'A comment cannot be longer than 1000 characters.',
  EDIT_FAILED: 'Failed to update the comment'
};

export const createPoForm = {
  REQUIRED: 'Required',
  VENDOR_REQUIRED: 'Vendor is required',
  ORDER_REQUIRED: 'Order No is required.',
  TOTAL_INCORRECT: 'Total is invalid. It must contain only digits.',
  TOTAL_REQUIRED: 'Total must not be empty.',
  TAX_INCORRECT: 'Tax must be a number or a percentage (e.g., 10 or 10%).',
  DESCRIPTION_LENGTH: 'Description must not be greater than 30 characters.',
  QUANTITY_INCORRECT: 'Quantity must contain only digit.',
  UNIT_PRICE_INCORRECT: 'Unit Price must contain only digit.',
  REQUIRED_FOR_ERP: 'Required to send to ERP',
  FETCH_PO: 'Fetch PO',
  SEND_TO_ERP: 'Send PO to ERP',
  CREATE: 'Create',
  PO_NUMBER_PLACEHOLDER: 'Enter PO Number',
  PO_NUMBER_REQUIRED: 'Please enter a PO number to fetch.',
  PO_NOT_FOUND: 'PO not found in ERP.',
  FETCH_SUCCESS: 'PO details fetched successfully.',
  FETCH_FAILED: 'Failed to fetch PO details.',
  ERP_SUCCESS: 'Document sent to ERP successfully.',
  ERP_FAILED: 'Failed to send document to ERP.',
  INVALID_FILE_TYPE: 'Invalid file type for ERP document.'
};

export const googleAuth = {
  BUTTON: 'Connect to Google Drive',
  BLOCKED: 'Popup blocked! Please allow popups for this website.',
  SUCCESS: 'Google Drive connected successfully.',
  CANCELLED: 'Google Drive was not connected. The Google sign-in was cancelled or refused.',
  DISCONNECT: 'Disconnect Google Drive'
};

export const customFilter = {
  SAVE: 'Save',
  CLEAR: 'Clear'
};

export const codesVisibility = {
  HEADER: 'Code Visibility',
  SUB_HEADING:
    'Configure code ranges to hide from selected users. Each group applies its exclusion ranges to the assigned users.',
  EXCLUDE_ACCESS: 'Exclude Access For',
  SELECT_ALL: 'Select all',
  ALL_USERS: 'All users',
  ADD_VISIBILITY_GROUP: 'Add Visibility Group',
  CANCEL: 'Cancel',
  SAVE: 'Save Changes',
  ADD_RANGE: 'Add Range',
  NO_GROUPS: 'No groups configured',
  INVALID_RANGE: '"From" must not be greater than "To"',
  RANGE_REQUIRED: 'Add at least one complete range',
  USERS_REQUIRED: 'Select at least one user to exclude'
};

/**
 * The code types that can be range-restricted. Every type stores the same
 * { ranges: [{ from, to }], restrictedUsers: [] } group shape under its own key in
 * company.codesVisibilityRanges, so the modal (and the BE filter) iterates this
 * config instead of special-casing each key.
 *
 *   { glAccount: [...groups], costId: [...groups], jobId: [...groups] }
 *
 * `label`/`labelPlural` are defaults only — cost id and job id are re-labelled per
 * ERP at render time (Cost Code / Item, Project Id). `pattern` is the allowed input:
 * GL accounts are numeric in every supported ERP, while cost/job ids are frequently
 * alphanumeric (e.g. "01-100A").
 */
export const codeVisibilityTypes = [
  {
    key: 'glAccount',
    label: 'GL Account',
    labelPlural: 'GL Accounts',
    pattern: /^\d+$/
  },
  {
    key: 'costId',
    label: 'Cost Id',
    labelPlural: 'Cost Ids',
    pattern: /^[A-Za-z0-9./_-]+$/
  },
  {
    key: 'jobId',
    label: 'Job Id',
    labelPlural: 'Job Ids',
    pattern: /^[A-Za-z0-9./_-]+$/
  }
];
export const accountantAssignment = {
  SELECT_ACCOUNTANTS: 'Select Accountant and assign PayControl',
  ADD_ACCOUNTANT: 'Add Accountant',
  ACCOUNTANT: 'Accountant',
  PAYCONTROL_NAME: 'PayControl'
};

// Bulk "Assign Pay Control" action on the documents table.
// Custom folders: company-configured tabs on the documents page. See
// utils/customFolders.js.
export const customFolders = {
  SECTION_TITLE: 'Custom Folders',
  SECTION_HINT: 'Extra tabs on the documents page, after On Hold.',
  NO_FOLDERS: 'No folders configured',
  CONFIGURE: 'Configure',
  MODAL_TITLE: 'Custom Folders',
  MODAL_INTRO:
    'Up to five extra tabs on the documents page. An automatic folder collects documents by type; a manual folder holds whatever you move into it.',
  ADD_FOLDER: 'Add folder',
  ADD_FROM_TEMPLATE: 'Add from template',
  TEMPLATE_DELIVERY_TICKETS: 'Delivery Tickets (automatic)',
  TEMPLATE_RETENTION_INVOICES: 'Retention Invoices (manual)',
  NAME: 'Folder name',
  MODE: 'How documents get in',
  MODE_AUTO: 'Automatic: by document type',
  MODE_MANUAL: 'Manual: someone moves them',
  DOCUMENT_TYPE: 'Document type',
  STAGES: 'Only from these tabs',
  STAGES_ALL: 'Every tab',
  ENABLED: 'Shown on the documents page',
  REMOVE: 'Remove folder',
  SAVE: 'Save',
  CANCEL: 'Cancel',
  ERROR_NAME_REQUIRED: 'Give the folder a name',
  ERROR_NAME_TOO_LONG: 'Folder names are at most 40 characters',
  ERROR_NAME_RESERVED: 'That name belongs to a built-in tab',
  ERROR_NAME_DUPLICATE: 'Two folders cannot share a name',
  ERROR_TYPE_REQUIRED: 'Pick the document type an automatic folder collects',
  ERROR_TOO_MANY: 'At most five folders',
  MOVE_TO: 'Move to',
  SELECT_FOLDER: 'Move the selected documents to',
  NO_MANUAL_FOLDERS: 'No manual folders configured',
  REMOVE_FROM_FOLDER: 'Remove from folder',
  MOVE_SUCCESS: 'Documents moved',
  MOVE_FAILED: 'Could not move documents',
  UNKNOWN_FOLDER: 'Folder',
  IN_FOLDER: 'In folder'
};

export const combineDocumentsText = {
  COMBINE: 'Combine',
  TITLE: 'Combine Documents',
  DOCUMENT_TYPE: 'Document type',
  CONFIRM: 'Combine',
  CANCEL: 'Cancel',
  SUCCESS: 'Documents combined. The new document is being processed.',
  FAILED: 'Failed to combine documents',
  TOOLTIP: 'Merge the selected Pending documents into one document',
  summary: (count) =>
    `${count} documents will be merged into one, in the order they were selected.`,
  warning: (count) =>
    `The new document is sent for extraction again, and the ${count} original documents will be deleted.`
};

// The documents-list Note column (utils/documentNote.js).
export const documentNoteText = {
  HEADER: 'Note',
  ADD_NOTE: 'Add note',
  EDIT_NOTE: 'Edit note',
  PLACEHOLDER: 'Why is this document waiting? e.g. waiting on change order approval',
  SAVE: 'Save',
  CANCEL: 'Cancel',
  CLEAR: 'Clear',
  SAVED: 'Note saved',
  CLEARED: 'Note cleared',
  SAVE_FAILED: 'Could not save the note',
  SHORTCUT_HINT: 'Ctrl/Cmd + Enter to save'
};

export const payControlAssignment = {
  ASSIGN_PAY_CONTROL: 'Assign Pay Control',
  SELECT_PAY_CONTROL: 'Select a pay control',
  NO_PAY_CONTROLS: 'No pay controls available',
  ASSIGN_SUCCESS: 'Pay control assigned successfully',
  ASSIGN_FAILED: 'Failed to assign pay control',
  REMOVE_PAY_CONTROL: 'Remove Pay Control',
  REMOVE_SUCCESS: 'Pay control removed successfully',
  REMOVE_FAILED: 'Failed to remove pay control'
};

// Canvas review column. The width is user-adjustable (dragged divider, persisted
// per browser) so the extracted values can be read without opening each dropdown.
// DEFAULT_WIDTH is the width the canvas shipped with — keep it as the fallback so
// a browser with no stored preference looks exactly as it did before.
export const canvasLeftColumn = {
  DEFAULT_WIDTH: 450,
  MIN_WIDTH: 380,
  // Cap as a share of the viewport: the document image has to stay usable, and
  // the connector lines need somewhere to travel.
  MAX_WIDTH_RATIO: 0.55,
  STORAGE_KEY: 'bh.canvas.leftWidth',
  DIVIDER_WIDTH: 6,
  KEYBOARD_STEP: 16,
  LABEL: 'Resize document details'
};

// Commitment discrepancy email (canvas): the "Create Email" button beside the Total's
// PO/SC mismatch warning, and the modal that drafts, reviews and sends it.
export const commitmentDiscrepancyEmailText = {
  CREATE_EMAIL: 'Create Email',
  CREATE_EMAIL_BUTTON_TOOLTIP:
    'Email a user in your company about what does not match the purchase order or subcontract',
  DISABLED_NO_NUMBER: 'Enter a PO or subcontract number and run Match to check this invoice',
  DISABLED_NOT_CHECKED: 'Run Match to check this invoice against its PO or subcontract',
  DISABLED_NO_DISCREPANCIES: 'No discrepancies found with the PO or subcontract',
  TITLE: 'Email about this discrepancy',
  CLOSE: 'Close',
  LOADING: 'Drafting the email…',
  DRAFT_FAILED: 'Could not draft the email',
  NO_DISCREPANCY:
    'No discrepancies were found. You can still edit the email below and send it.',
  WHAT_DOES_NOT_MATCH: 'What does not match',
  AMOUNT_COMPARED: 'Invoice amount compared',
  AVAILABLE_ERP: 'Remaining in ERP',
  AVAILABLE_TOTAL: 'Commitment total',
  REMAINING_BH: 'Remaining in Beiing Human',
  OVER_BY: 'Over by',
  RECIPIENT: 'Send to',
  NO_RECIPIENTS: 'No signed-up users in your company to send to',
  SUBJECT: 'Subject',
  BODY: 'Message',
  CANCEL: 'Cancel',
  SEND: 'Send',
  SENT: 'Email sent',
  SEND_FAILED: 'Could not send the email'
};

// Multi-company login (tenancy/): the picker, Switch company, Settings → Companies
// and the invite banner. Shown only to people with more than one company, a
// pending invite, or (Add a company) the Owner or Support of a multi-company family.
export const companyChoice = {
  PICKER_TITLE: 'Choose a company',
  PICKER_SUBTITLE: 'You have access to more than one company. Choose the one to work in.',
  LAST_USED: 'Last used',
  PRIMARY: 'Primary',
  PENDING_INVITES: 'Invitations',
  INVITED_AS: (role, invitedBy) =>
    invitedBy ? `Invited as ${role} by ${invitedBy}` : `Invited as ${role}`,
  ACCEPT: 'Accept',
  DECLINE: 'Decline',
  INVITE_ACCEPTED: 'Invitation accepted. The company is now in your list.',
  INVITE_DECLINED: 'Invitation declined.',
  INVITE_FAILED: 'We could not update the invitation. Please try again.',
  NO_COMPANIES: 'You have no companies to open yet. Accept an invitation above, or contact your administrator.',
  SWITCH_COMPANY: 'Switch company',
  SWITCHING: 'Switching company…',
  SWITCH_FAILED: 'We could not open that company. Please try again.',
  SETTINGS_TITLE: 'Your companies',
  SETTINGS_SUBTITLE: 'The companies you can sign in to with this login.',
  CURRENT: 'Current',
  YOU_ARE_HERE: 'You are here',
  OPEN: 'Open',
  ADD_COMPANY: 'Add a company',
  ADD_COMPANY_HINT:
    'Creates a new company in your family, with you as its Owner. You can switch to it straight away.',
  ADD_COMPANY_FOR_OWNER_HINT:
    "Creates a new company in this family. The main company's Owner becomes its Owner, and you, the Accountants and the Sub Admins are added to it. You can switch to it straight away.",
  COMPANY_NAME: 'Company name',
  YOUR_NAME: 'Your name',
  PHONE: 'Phone number',
  CREATE: 'Create company',
  CANCEL: 'Cancel',
  COMPANY_ADDED: (name) => `${name} was created. You can switch to it now.`,
  ADD_FAILED: 'We could not create the company.',
  CREATED_BUT_NOT_ADDED: (name) =>
    `${name} was created for the Owner, but you could not be added to it, so it is not in your list. Do not create it again.`,
  INVITE_BANNER: (count) =>
    count === 1
      ? 'You have been invited to another company.'
      : `You have been invited to ${count} other companies.`,
  VIEW_INVITES: 'View',
  // Profile menu, and the Companies & routing page it opens.
  COMPANIES_PAGE_TITLE: 'Companies & routing',
  COMPANIES_PAGE_SUBTITLE:
    'The companies you can sign in to, your invitations, and how invoices are routed between them.',
  COMPANIES_PAGE_LINK: 'Companies, invitations and routing now have their own page.',
  OPEN_COMPANIES_PAGE: 'Open Companies & routing',
  SETTINGS_MENU: 'Settings',
  INVITE_COUNT: (count) => (count === 1 ? '1 invite' : `${count} invites`)
};

// Multi-company families: routing, the Unidentified tab, Send to company and
// the admin-panel family switch (src/tenancy/families.js).
// The title and one-line description a home-page tab shows in its header band
// when it has no sub-tabs to choose between (headerSection.jsx), keyed by the
// header's `tab`. A tab missing here keeps its sub-tab row as before.
export const pageHeadings = {
  Dashboard: {
    title: 'Dashboard',
    subtitle: 'Your documents at a glance, by status.'
  },
  downloads: {
    title: 'Downloads',
    subtitle: 'The export files you have generated, and whether each reached your ERP.'
  },
  integration: {
    title: 'Integration',
    subtitle: 'Your ERP connection, and syncing its lists into Beiing Human.'
  },
  features: {
    title: 'Policy',
    subtitle: 'Who approves each document, and in what order.'
  }
};

export const familyText = {
  ROUTING_TITLE: 'Mail routing',
  ROUTING_SUBTITLE:
    "Invoices emailed to the family's main inbox are filed in the company whose job prefix or ship-to address they carry.",
  ROUTING_ON: 'Routing on',
  ROUTING_ON_HINT: "Route documents arriving in this company's inbox to the right family company",
  USE_SHIP_TO: 'Use ship-to address',
  USE_SHIP_TO_HINT: 'When an invoice has no PO, match it by its ship-to address',
  PREFIXES: 'Job prefixes',
  PREFIXES_HINT:
    'A PO that starts with one of these is filed in this company. Separate several with commas.',
  ADDRESSES: 'Ship-to addresses',
  ADD_ADDRESS: 'Add address',
  REMOVE: 'Remove',
  STREET: 'Street',
  CITY: 'City',
  ZIP: 'ZIP',
  SAVE: 'Save routing',
  SAVED: 'Routing saved',
  SAVE_FAILED: 'We could not save the routing settings.',
  UNIDENTIFIED: 'Unidentified',
  UNIDENTIFIED_EMPTY: 'No unidentified documents. Everything that arrived was filed in a company.',
  UNIDENTIFIED_LOAD_FAILED: 'We could not load the unidentified documents.',
  RECEIVED: 'Received',
  VENDOR: 'Vendor',
  DOCUMENT_NUMBER: 'Number',
  PO: 'PO',
  TYPE: 'Type',
  REASON: 'Why it was not filed',
  // The Unidentified tab's extra column on the shared documents table.
  WHY_NOT_ROUTED: 'Why not routed',
  SEND_TO_COMPANY: 'Send to company',
  SEND_TITLE: 'Send to another company',
  SEND_SUMMARY: (count) =>
    `${count} document${count === 1 ? '' : 's'} will be filed in the company you choose.`,
  SEND_HINT:
    'A document nobody has edited yet is moved as it is. Any other is re-extracted in the new company and removed from this one.',
  TARGET_COMPANY: 'Company',
  SEND: 'Send',
  CANCEL: 'Cancel',
  SEND_FAILED: 'We could not send the documents.',
  sendResult: ({ moved, copied, refused }) => {
    const parts = [];
    if (moved) parts.push(`${moved} moved`);
    if (copied) parts.push(`${copied} sent for extraction`);
    if (refused) parts.push(`${refused} not sent`);
    return parts.length ? `${parts.join(', ')}.` : 'Nothing was sent.';
  },
  REFUSED_TITLE: 'Not sent',
  FAMILY_SWITCH: 'Multi-company',
  FAMILY_TITLE: (name) => `Multi-company — ${name}`,
  FAMILY_ENABLED: 'Multi-company on',
  FAMILY_ENABLED_HINT:
    'People in this family can hold a login in several of its companies, and its Owner can add companies.',
  FAMILY_FROZEN: 'Frozen',
  FAMILY_FROZEN_HINT:
    'Stops new companies, invites and routing changes, and keeps the family on the multi-company code.',
  FAMILY_ACTIVE: 'Running on the multi-company code',
  FAMILY_INACTIVE: 'Running on the classic code',
  FAMILY_ENABLED_BY: (by, at) => `Switched on by ${by}${at ? ` on ${at}` : ''}`,
  FAMILY_MEMBERS: (count) =>
    count === 1
      ? '1 person in this family also belongs to another company.'
      : `${count} people in this family also belong to another company.`,
  FAMILY_OFF_TITLE: 'Switch multi-company off?',
  FAMILY_OFF_DESCRIPTION:
    'The family goes back to the classic code. Routing and the Unidentified tab stop, and the Owner can no longer add companies.',
  FAMILY_OFF_CONFIRM: 'Switch off',
  FAMILY_NOT_PRIMARY: (primaryId) =>
    `This company is attached to another family. Switch it from the family's main company${
      primaryId ? ` (${primaryId})` : ''
    }.`,
  FAMILY_SAVE_FAILED: 'We could not change the multi-company switch.',
  FAMILY_LOAD_FAILED: 'We could not read the multi-company switch.',
  CLOSE: 'Close'
};

// The review screen (canvas): the labelled top-bar buttons, the ⋯ More menu and
// the decision footer's status line. Wording only — every control these label
// keeps the handler and the condition it had before it was grouped.
export const reviewScreenText = {
  ACTIVITY: 'Activity',
  PO_AND_DELIVERY_TICKETS: 'PO & delivery tickets',
  ATTACH_DELIVERY_TICKET: 'Attach delivery ticket',
  ATTACH_DELIVERY_TICKET_TOOLTIP:
    'Remove/Attach Delivery Ticket (Only approved delivery tickets can be attached)',
  MORE: 'More',
  MORE_ACTIONS: 'More actions',
  DOWNLOAD_ORIGINAL_FILES: 'Download original files',
  SYNC_FROM_FOUNDATION: 'Sync from Foundation',
  DELETE_DOCUMENT: 'Delete document',
  CHECKING_DUPLICATION: "Checking this invoice number isn't already in use…",
  LOADING: 'Loading…',
  thingsToFix: (count) =>
    `${count} ${count === 1 ? 'thing' : 'things'} to fix before approving`,
  READY_TO_APPROVE: 'Ready to approve.',
  readyNext: (names) => `Ready to approve. Next: ${names}`,
  // Above the decision buttons when nothing is left to fix (approveStatusLine).
  nextApprover: (names) => `Next approver: ${names}`,
  LAST_APPROVER: 'You are the last approver',
  // The one-line "to fix" bar: the first reason, then how many more.
  moreToFix: (count) => `+${count} more`,
  SHOW_LESS: 'Show less',
  // The line-items strip.
  LINE_ITEMS: 'Line items',
  lineItemsLabel: (count, errorCount) =>
    errorCount > 0
      ? `Line items, ${errorCount} ${errorCount === 1 ? 'error' : 'errors'}`
      : `Line items, ${count}`,
  CONSOLIDATE: 'Consolidate',
  CONSOLIDATE_TOOLTIP: 'Consolidate line items into one line',
  // One sentence per condition of the Approve button's `disabled` rule
  // (utils/approveBlockers.js). Plain words: the reviewer should know what to do.
  blockers: {
    VISTA_FLOW: 'The Vista coding is incomplete for the selected type.',
    PAYMENT_TERM: "The payment term isn't one of the ERP's payment terms.",
    SAME_CODES: 'Account details and line item codes must be the same.',
    DT_LINE_ITEM: 'A delivery ticket needs at least 1 line item.',
    VISTA_LINE_ITEM: 'There must be at least 1 line item.',
    PO_TOTAL: "The total doesn't match the PO / subcontract.",
    PO_VENDOR: 'The PO / subcontract belongs to a different vendor.',
    INACTIVE_BUDGET_CODES: 'A job, phase or cost type is no longer active in the budget.',
    PO_ERP_BLOCKED: 'The PO / subcontract is closed or was not found in the ERP.',
    DUPLICATE_NUMBER: 'This document number is already used for this vendor.',
    VENDOR_NOT_IN_ERP: "The vendor isn't one of the ERP's vendors.",
    FIELD_ERRORS: 'Some document fields have errors.',
    PAYMENT_ERRORS: 'Some payment fields have errors.',
    LINE_ITEM_ERRORS: 'Some line items have errors.',
    FIELDS_NOT_VERIFIED: 'Not every field is verified yet.',
    TYPE_NOT_VERIFIED: "The document type isn't verified.",
    VENDOR_NUMBER_NOT_VERIFIED: "The vendor number isn't verified.",
    VENDOR_NUMBER_MISSING: 'The vendor number is missing.',
    OPEN_QUESTION: 'There is an open question on this document.',
    TOTAL_MISMATCH: "The line items don't add up to the document total."
  }
};
